/**
 * Global utils
 * @type {Object}
 */
import $ from 'jquery';
import 'imports-loader?jquery=jquery!owl.carousel';
import 'imports-loader?jquery=jquery!sticky-kit/dist/sticky-kit';
import 'jquery-datetimepicker';
import countdown from 'countdown';
import GMaps from 'gmaps';
import gMapStyle from './mixins/gmap-styles.js';
import { TweenMax, Back, Power0 } from 'gsap';
import Masonry from 'masonry';
import ImagesLoaded from 'imagesloaded';
import 'intl-tel-input/build/js/intlTelInput';
import Orejime from 'orejime';
import Gumshoe from 'gumshoejs/dist/gumshoe.polyfills.min';
import { CountUp } from 'countup.js';

let globalUtils = {
    popupClasses: ['popup-login-open', 'popup-signup-open', 'popup-lostpass-open', 'popup-share-open', 'popup-copy-open', 'popup-coordonnee-open', 'popup-donation-open', 'popup-donation-choice-open', 'popup-member-biographie-open', 'popup-donation-project-choice-open', 'popup-thanks-open', 'popup-registred-open', 'popup-delete-my-account-open', 'popup-deleted-account-open', 'popup--gallery-preview-open', 'popup-verify-email-open', 'popup-forgot-open', 'popup-newsletter-open', 'popup-share-confirm-open', 'popup-refresh-open', 'popup-membership-individual-choice-open', 'popup-newsletter-registration-open', 'popup-payment-open', 'popup-problem-occured-open', 'popup-pageSupporter-open', 'popup-image-grille'],

    newsletterRecaptchaRendered: false,
    stripe: null,
    card: null,
    is_equalHeight: false,

    formatedPopupClasses () {
        return this.popupClasses.join(' ');
    },

    initialize () {
        console.info('Global utils initialized');

        this.tagCloud();
        this.manageLogoValidation();
        this.manageUrlValidation();
        this.buildAboutProjectCarousel();
        this.buildArtistDetailGalleryCarousel();
        this.buildCounterparts();
        this.buildGallery();
        this.attachSliderVideoHandler();
        // this.attachVideoCoverHandler();
        this.customVideoCoverHandler();
        this.buildSlideShow();
        this.donationFeedBack();
        this.updateBodyClass();
        this.responsiveTable();
        this.buildCookieConsent();
        // this.checkNewsletterCookie(); For popup newsletter on first navigation
        this.initStrateKeyFigure();
        // this.verticalTimeline();
        this.cardActive();
        this.CTAFixed();
        this.AddActiveClass();
        this.projectsList();

        let self = this;
        let isPrizeMoreThanThree = false;
        let scrollAdjust = () => {
            const scrollPos = $(document).scrollTop();

            if (scrollPos > 50) {
                $('body').addClass('switch-menu');

                if ((scrollPos > ($(window).height() - 140)) && ($('.shortlist-content--header').length > 0) && ($('.shortlist-content--header').length === 0)) {
                    $('body').addClass('shortlist-open');
                }

                if (document.querySelector('.nomine-count-down') || document.querySelector('.shortlist-content--header')) {
                    if ($('.nomine-count-down').length > 0) {
                        if (document.getElementById('shortlist-content')) {
                            if ((scrollPos >= ($(window).height())) && (document.getElementById('shortlist-content').offsetTop <= scrollPos)) {
                                $('body').addClass('shortlist-fixed-header');
                            } else {
                                $('body').removeClass('shortlist-fixed-header');
                            }
                        }
                    } else {
                        if (!scrollPos >= ($(window).height())) {
                            $('body').removeClass('shortlist-fixed-header');
                        }
                    }
                }
            } else if (scrollPos === 0) {
                $('body').removeClass('shortlist-open');
                $('body').removeClass('switch-menu');
            } else {
                $('body').removeClass('switch-menu');
            }

            $('body').removeClass('menu--user--open');
        };

        // Link to project list form competition history mobile
        if ($('.section--projects').length > 0) {
            $('#members-list-select-history').change(function () {
                const selectedOption = $(this).find('option:selected');

                console.log('option', selectedOption);

                const competitionUrl = selectedOption.data('competition-url');

                if (competitionUrl) {
                    window.location.href = competitionUrl;
                }
            });

            let url = window.location.href;

            if (url.indexOf('map-view') !== -1) {
                $('#members-list-select').val('#project-map-anchor');
            }
        }

        // Find if we have more than 3 prizes
        if ($('.header--shortlist')[0]) {
            isPrizeMoreThanThree = parseInt($($('.header--shortlist')[0]).data('nbprize'), 10) > 3;
        }

        let $benefiting = document.getElementById('benefiting');

        if ($benefiting) {
            if ($benefiting.querySelector('select')) {
                $benefiting.querySelector('select').addEventListener('change', function () {
                    const $val = this.value;

                    $benefiting.querySelectorAll('.benefiting_fedora')
                        .forEach(function (el) {
                            el.style.display = 'none';
                        });
                    $benefiting.querySelector('.benefiting_fedora-' + $val).style.display = 'block';
                });
            }
        }

        // Init on load
        scrollAdjust();

        /**
         * Header Sticky
         * Trigger on scroll
         */
        $(window).on('scroll', scrollAdjust);

        /**
         * Sticky column
         */
        let setSticky = function () {
            if ($('.sticky-parent').length > 0) {
                let limitWidth = 768;

                if ($('.press-room-page').length > 0) {
                    limitWidth = 1024;
                }
                if (($(window).width() >= limitWidth)) {
                    $('.sticky-col:not(.sticky-doned)').each(function () {
                        $(this).stick_in_parent({
                            parent: '.sticky-parent',
                            offset_top: $('.main-new-menu').outerHeight()
                        });
                        $(this).addClass('sticky-done');
                    });
                } else {
                    $('.sticky-col.sticky-done').each(function () {
                        $(this).trigger('sticky_kit:detach');
                        $(this).removeClass('sticky-done');
                    });
                }
            }
            if ($('.sticky-parent-project').length > 0) {
                if (($(window).width() >= 768)) {
                    $('.sticky-col-project:not(.sticky-doned)').each(function () {
                        $(this).stick_in_parent({
                            parent: '.sticky-parent-project',
                            spacer: false,
                            offset_top: ($('.main-new-menu').outerHeight() - 30)
                        });
                        $(this).addClass('sticky-done');
                    });
                } else {
                    $('.sticky-col-project.sticky-done').each(function () {
                        $(this).trigger('sticky_kit:detach');
                        $(this).removeClass('sticky-done');
                    });
                }
            }

            if ($('.sticky-parent--application').length > 0) {
                if (($(window).width() >= 1024)) {
                    $('.sticky-col--application:not(.sticky-doned)').each(function () {
                        $(this).stick_in_parent({
                            parent: '.sticky-parent--application',
                            offset_top: $('.main-new-menu').outerHeight()
                        });
                        $(this).addClass('sticky-done');
                    });
                } else {
                    $('.sticky-col--application.sticky-done').each(function () {
                        $(this).trigger('sticky_kit:detach');
                        $(this).removeClass('sticky-done');
                    });
                }
            }
        };

        let resizeTimer;

        $(window).on('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(setSticky, 250);
            self.updateBodyClass();
            setAnimPropertiesForShortlistPrize();
            self.is_equalHeight = true;
            self.equalHeight('titleContentEqualHeight');
            self.equalHeight('subtitleEqualHeight');
            self.equalHeight('descBiennalHeight');
            self.equalHeight('catBiennalHeight');
            self.equalHeight('impactsBiennalHeight');
            // self.verticalTimeline();
        });
        setSticky();

        /**
         * Images copyright
         */
        $('.copyright--helper').each(function () {
            $(this).mouseover(function () {
                $(this).prev('.copyright--text')
                    .addClass('copyright--slide');
            });
        });
        $('.copyright--helper').each(function () {
            $(this).mouseout(function () {
                $(this).prev('.copyright--text')
                    .removeClass('copyright--slide');
            });
        });

        /**
         * Menu
         */
        $('.main-menu--item > a').click(
            function () {
                // console.log('test parent parent',
                //     $(this).parent().parent('ul')
                //         .hasClass('main-menu--list'),
                //     '<br>',
                //     'test parent',
                //     $(this).parent('ul')
                //         .hasClass('main-menu--list'),
                //     '<br>test parents',
                //     $(this).parents('ul')
                //         .hasClass('main-menu--list'));
                if ($(this).parent()
                    .parent('ul')
                    .hasClass('main-menu--list') && $(this).parent('li')
                    .hasClass('submenu--open')) {
                    // console.log('test click parent for close');
                    $(this).parent('li')
                        .removeClass('submenu--open');
                    $('.submenu').removeClass('open');
                    $('.submenu .main-menu--item').removeClass('submenu--open');
                } else if ($(this).parent()
                    .parent('ul')
                    .hasClass('main-menu--list') && !$(this).parent('li')
                    .hasClass('submenu--open')) {
                    // console.log('test remove with submenu');
                    $('.main-menu--item').removeClass('submenu--open');
                    $(this).parent('.main-menu--item')
                        .addClass('submenu--open');
                    $('.submenu').removeClass('open');
                } else {
                    console.log('test else');
                    if ($(this).parent('.main-menu--item')
                        .hasClass('submenu--open')) {
                        $('.submenu').removeClass('open');
                        $(this).parent('.main-menu--item')
                            .removeClass('submenu--open');
                    } else {
                        if ($(this).parents('.main-menu--item')
                            .hasClass('submenu--open')) {
                            if ($(this).parents('.submenu')) {
                                $(this).parents('.submenu')
                                    .addClass('open');
                            }
                            $(this).parent('.main-menu--item')
                                .addClass('submenu--open');
                        } else {
                            $('.main-menu--item').removeClass('submenu--open');
                            if ($(this).parents('.submenu')) {
                                $(this).parents('.submenu')
                                    .addClass('open');
                            }

                            $(this).parent('.main-menu--item')
                                .addClass('submenu--open');
                        }
                    }
                }

                if ($('.submenu--open').length > 0) {
                    $('body').addClass('submenu-active');

                    if (($(window).width() < 768)) {
                        $('body').addClass('bc-submenu-open');
                    }
                } else {
                    $('body').removeClass('submenu-active');

                    if (($(window).width() < 768)) {
                        $('body').removeClass('bc-submenu-open');
                    }
                }

                if (document.querySelector('.submenu--open  .submenu')) {
                    let scrollHeight = document.querySelector('.submenu--open .submenu').scrollHeight;

                    $('.main-new-menu-wrapper .container').css({ height: 'inherit' });
                    setTimeout(
                        function () {
                            if (scrollHeight > window.innerHeight) {
                                $('.main-new-menu-wrapper .container').css({ height: scrollHeight + 'px' });
                            } else  {
                                $('.main-new-menu-wrapper .container').css({ height: 'inherit' });
                            }
                        }, 200
                    );
                }
            }
        );
        // } else {
        //     $('.main-menu--item').hover(
        //         function () {
        //             $('.submenu--open').removeClass('submenu--open');
        //             $('.submenu--willclose').removeClass('submenu--willclose');
        //             $(this).addClass('submenu--open');
        //         },
        //         function () {
        //             $(this).removeClass('submenu--open');
        //             $(this).addClass('submenu--willclose');
        //             let el = $(this);

        //             el.interval = setInterval(function () {
        //                 el.removeClass('submenu--willclose');
        //                 clearInterval(el.interval);
        //             }, 1000);
        //         }
        //     );
        // }

        /**
         * Button prize roll over
         */
        $('.btn-prizes').each(function () {
            $(this).on('mouseover', function () {
                let $color = $(this).data('color');

                $(this).css({
                    'color': '#ffffff',
                    'background': $color,
                    'border-color': $color
                });
            });
            $(this).on('mouseout', function () {
                let $color = $(this).data('color');

                $(this).css({
                    'color': $color,
                    'background': '#ffffff',
                    'border-color': $color
                });
            });
        });

        $('.btn-menu').click(
            function () {
                $('body').toggleClass('menu-opened');
                $('body').removeClass('menu--user--open');
                $('body').removeClass('bc-submenu-open');
                $('body').removeClass('submenu-active');
                $('.main-menu--item').removeClass('submenu--open');
                $('.submenu').removeClass('open');

                return (false);
            }
        );

        $('.menu--user .link-show-login, .error-message .link-show-login, .is--not-logged').click(
            function () {
                let btn = $('.btn-signup');

                window.currentForm = 'register';
                $('body').addClass('popup-open popup-signup-open');
                window.grecaptcha.render('grecaptcha-sign-up', {
                    'sitekey': $('#grecaptcha-sign-up').data('sitekey'),
                    'callback': function (token) {
                        // return new Promise(function (resolve) {
                        return new Promise(function () {
                            base.recaptchaCallback(token, $(btn), base.jxComplete);
                        });
                    },
                    'size': 'invisible'
                });

                window.isInitializedRecaptchaSignIn = true;
                $('.form-wrapper.email > .error-message').text('');
                $('.form-wrapper.password > .error-message').text('');

                return (false);
            }
        );
        $('.menu--user .link-show-login-menu').click(
            function () {
                $('body').toggleClass('menu--user--open');
                $('body').removeClass('menu-opened');

                return (false);
            }
        );

        $('.is--not-logged').click(
            function () {
                $('body').addClass('popup-open popup-signup-open');

                return (false);
            }
        );

        $('.menu-right .link-show-login-menu').click(
            function () {
                $('body').toggleClass('menu--user--open');
                $('body').removeClass('menu-opened');

                return (false);
            }
        );

        $('.is--not-logged').click(
            function () {
                $('body').addClass('popup-open popup-login-open');
                $('.form-wrapper.email > .error-message').text('');
                $('.form-wrapper.password > .error-message').text('');

                return (false);
            }
        );
        $('.menu-right .link-show-login-menu').click(
            function () {
                $('body').toggleClass('menu--user--open');
                $('body').removeClass('menu-opened');

                return (false);
            }
        );

        $('.link-donation-choice').click(
            function () {
                $('body').addClass('popup-open popup-donation-choice-open');

                return (false);
            }
        );

        $('#next-country-donation').click(
            function () {
                let country = $('#donation_by_country').val();

                // eslint-disable-next-line eqeqeq
                if (country.length != 0) {
                    // eslint-disable-next-line eqeqeq
                    if (country == 'ot') {
                        $('#next-country-donation').hide();
                        $('.message-donation').removeClass('hidden-message');
                        // $('#donation_by_country').addClass('disabled');
                    } else {
                        if (country !== 'fr') {
                            console.log('🚀 nextcountry_form ~ country', country);
                            $('#nextcountry_form').attr('target', '_blank');
                        } else {
                            let target = $('#nextcountry_form').attr('target');

                            if (typeof target !== 'undefined' && target !== false) {
                                $('#nextcountry_form').removeAttr('target');
                            }
                        }
                        $('#nextcountry_form').submit();
                    }
                }
            }
        );

        $('#next-country-donation-individual').click(function () {
            let $formCountry = $('#donation_by_country_individual');
            let $messageEmptyCountry = $('.message-empty-country');
            let $messageDonation = $('.message-donation');
            let $nextCountryDonationIndividual = $('#next-country-donation-individual');
            let $nextCountryFormIndividual = $('#nextcountry_form_individual');

            let country = $formCountry.val();

            if (country.length !== 0) {
                $messageEmptyCountry.addClass('hidden-message');

                if (country === 'ot') {
                    $nextCountryDonationIndividual.hide();
                    $messageDonation.removeClass('hidden-message');
                } else if (country === 'null') {
                    $nextCountryDonationIndividual.show();
                    $messageEmptyCountry.removeClass('hidden-message');
                } else {
                    $nextCountryFormIndividual.attr('target', '_blank');
                    $nextCountryFormIndividual.submit();
                }
            }
        });

        $('#donation_by_country').change(function () {
            // eslint-disable-next-line eqeqeq
            if ($(this).val() == 'ot') {
                $('#next-country-donation').hide();
                $('.message-donation').removeClass('hidden-message');
            } else {
                $('#next-country-donation').show();
                $('.message-donation').addClass('hidden-message');
            }
        });

        $('#donation_by_country_individual').change(function () {
            $('.message-empty-country').addClass('hidden-message');
            $('.message-donation').addClass('hidden-message');
            $('.message-uk-strict').addClass('hidden-message');

            const selectedValue = $(this).val();

            if (selectedValue === 'ot') {
                $('#next-country-donation-individual').hide();
                $('.message-donation').removeClass('hidden-message');
            } else if (selectedValue === 'gb') {
                $('#next-country-donation-individual').show();
                $('.message-uk-strict').removeClass('hidden-message');
            } else {
                $('#next-country-donation-individual').show();
            }
        });

        $('.member-biographie').click(
            function () {
                let $el = $(this).find('> *')
                    .clone();
                let juryClass = $(this).hasClass('jury') ? 'jury' : '';

                $('#popup--member-biographie')
                    .find('.biographie-wrapper')
                    .removeClass(juryClass)
                    .empty();

                $('#popup--member-biographie')
                    .find('.biographie-wrapper')
                    .addClass(juryClass)
                    .append($el);
                document.querySelector('body').classList += ' popup-open popup-member-biographie-open';
            }
        );

        if ($('.grille-item')) {
            $('.grille-item').click(
                function () {
                    const $imgSlug = $(this)
                        .find('img')
                        .attr('src');
                    const $title = $(this)
                        .find('p')
                        .text();
                    const $description = $(this)
                        .find('textarea')
                        .val();
                    let popupClass = 'image-grille';
                    let $divImg = document.createElement('div');
                    let $divInfo = document.createElement('div');
                    let $pTitle = document.createElement('p');
                    let $pDescription = document.createElement('p');
                    let $img = document.createElement('img');

                    console.log('data', $title, $description);
                    $divImg.classList.add('image');
                    $img.setAttribute('src', $imgSlug);
                    $divImg.append($img);
                    $divInfo.className = 'info';
                    $pTitle.className = 'title';
                    $pTitle.textContent = $title;
                    $pDescription.className = 'description';
                    $pDescription.textContent = $description;
                    $divInfo.append($pTitle);
                    $divInfo.append($pDescription);
                    $('#popup--member-biographie')
                        .addClass(popupClass)
                        .find('.biographie-wrapper')
                        .removeClass(popupClass)
                        .empty();

                    $('#popup--member-biographie')
                        .addClass(popupClass)
                        .find('.biographie-wrapper')
                        .addClass(popupClass)
                        .append($divImg)
                        .append($divInfo);
                    document.querySelector('body').classList += ' popup-open popup-member-biographie-open';
                }
            );
        }

        if ($('.popup-supporter')) {
            $('.popup-supporter').click(
                function () {
                    const $el = $(this)
                        .find('.popup-data > *')
                        .clone();

                    $('#pageSupporter')
                        .find('.popup-content-wrapper')
                        .empty();
                    $('#pageSupporter')
                        .find('.popup-content-wrapper')
                        .append($el);
                    document.querySelector('body').classList += ' popup-open popup-pageSupporter-open';
                }
            );
        }

        $('.link-membership-individual-choice, .link-membership-corporate-choice').on('click', function () {
            $('body').addClass('popup-open popup-membership-individual-choice-open');

            return (false);
        });

        let base = this;

        // id: register-header-newsletter Header
        $('form#register-header-newsletter button').on('click', function (e) {
            e.preventDefault();

            let email = $('form#register-header-newsletter input[name=subscriber_email]').val();

            if (email) {
                $('form#form-newsletter-subscription input[name=email]').val(email);
            }

            base.showNewsletterPopup();

            return false;
        });

        // id: register-newsletter Footer
        $('form#register-newsletter button').on('click', function (e) {
            e.preventDefault();

            let email = $('form#register-newsletter input[name=subscriber_email]').val();

            if (email) {
                $('form#form-newsletter-subscription input[name=email]').val(email);
            }

            base.showNewsletterPopup();

            return false;
        });

        $('button#submit-newsletter').on('click', function (e) {
            e.preventDefault();

            let formNewsletterEmail = $('form#form-newsletter-subscription input[name=email]').val();
            let subscribeBtn = $('form#form-newsletter-subscription #submit-newsletter');

            if (!base.validateEmail(formNewsletterEmail)) {
                $('form#form-newsletter-subscription .email .error-message')
                    .text('Invalid email format');

                return false;
            } else {
                subscribeBtn.addClass('disabled');
                subscribeBtn.addClass('right-spin');

                window.grecaptcha.execute();

                $('form#form-newsletter-subscription .email .error-message')
                    .text('');
            }
        });

        let selectedCategory = false;

        function checkTgeIndividualMembershipCategory (firstload = false) {
            let categories = $('input.tge-individual');
            let isSelected = false;

            categories.each((index, element) => {
                if (element.checked) {
                    isSelected = true;
                    selectedCategory = element;
                }
            });

            if (!isSelected) {
                if (!firstload) {
                    $('.error-message.category').html('Please choose one membership category');
                    $('.error-message.category').show();
                }
            } else {
                $('.error-message.category').hide();
                let fees = $(selectedCategory).data('fees');

                $('.toggle-membership-category-text').html($(selectedCategory).data('text'));

                if (!fees) {
                    let url = 'https://donate.transnationalgiving.eu/';
                    let countryTge = $('#country_selected').val();

                    window.location.href = url + (countryTge !== '' ? countryTge : 'landing/fedora');
                } else {
                    // $('#individual-position').show();
                    // $('#genereal_information').show();
                    // $('#billing_adresse').show();
                    $('#representative').show();
                    // $('#key_contact_person').show();
                    $('#payement-method-section').show();
                    $('#create-account-section').show();
                    $('#payement_truthful').show();
                    $('#newsletter_fedora').show();
                    $('#submit-section').show();
                    $('#tge-individual-continue').hide();
                }
            }
        }

        $('a[data-behaviour=tge]').on('click', function () {
            checkTgeIndividualMembershipCategory();
        });

        function handleBillingAddress (element) {
            if ($(element).is(':checked')) {
                $('#name_of_organisation_billing').fadeIn('slow');
                $('#adress_billing').fadeIn('slow');
                $('#postal_code_billing').fadeIn('slow');
                $('#city_billing').fadeIn('slow');
                $('#country_code_billing').fadeIn('slow');
            } else {
                $('#name_of_organisation_billing').fadeOut('slow');
                $('#adress_billing').fadeOut('slow');
                $('#postal_code_billing').fadeOut('slow');
                $('#city_billing').fadeOut('slow');
                $('#country_code_billing').fadeOut('slow');
            }
        }

        $('input#different_billing_address').on('change', function (event) {
            handleBillingAddress(event.target);
        });

        $('input.tge-individual').on('change', function (event) {
            $('#individual-position').hide();
            $('#representative').hide();
            $('#payement-method-section').hide();
            $('#create-account-section').hide();
            $('#payement_truthful').hide();
            $('#newsletter_fedora').hide();
            $('#submit-section').hide();
            $('#tge-individual-continue').show();

            $('.toggle-membership-category-text').html($(event.target).data('text'));
        });

        $('body').keyup(
            function (event) {
                if ((event.which === 27) && $(this).hasClass('menu-opened')) {
                    $(this).removeClass('menu-opened');
                }
                if ((event.which === 27) && $(this).hasClass('popup-open')) {
                    if ($(this).hasClass('popup-login-open')) {
                        $(this).removeClass('popup-login-open');
                    }
                    if ($(this).hasClass('popup-lostpass-open')) {
                        $(this).removeClass('popup-lostpass-open');
                    }
                    if ($(this).hasClass('popup-signup-open')) {
                        $(this).removeClass('popup-signup-open');
                    }
                    if ($(this).hasClass('popup-share-open')) {
                        $(this).removeClass('popup-share-open');
                    }
                    if ($(this).hasClass('popup-copy-open')) {
                        $(this).removeClass('popup-copy-open');
                    }
                    if ($(this).hasClass('popup-member-biographie-open')) {
                        $(this).removeClass('popup-member-biographie-open');
                    }
                    if ($(this).hasClass('popup-pageSupporter-open')) {
                        $(this).removeClass('popup-pageSupporter-open');
                    }
                    if ($(this).hasClass('popup-image-grille')) {
                        $(this).removeClass('popup-image-grille');
                    }

                    if ($(this).hasClass('bc-submenu-open')) {
                        $(this).removeClass('bc-submenu-open');
                    }

                    if ($(this).hasClass('submenu-active')) {
                        $(this).removeClass('submenu-active');
                    }

                    if ($(this).hasClass('submenu--open')) {
                        $(this).removeClass('submenu--open');
                    }

                    $('.submenu').removeClass('open');
                    $(this).removeClass('popup-coordonnee-open');
                    $(this).removeClass('popup-donation-open');
                    $(this).removeClass('popup-thanks-open');
                    $(this).removeClass('popup-open');
                }

                return (false);
            }
        )
            .click(
                function () {
                    $('body').removeClass('menu--user--open');
                }
            );

        /**
         * Popup
         * @note popupOpenClasses [0] > login
         * @note popupOpenClasses [1] > signup
         * @note popupOpenClasses [2] > forgot password
         */
        let aPopupOpenClasses = this.popupClasses;
        let sPopupOpenClasses = this.formatedPopupClasses();

        $('.btn-signup').click(
            function () {
                let btn = this;

                window.currentForm = 'register';

                $('body').removeClass(sPopupOpenClasses);
                $('body').addClass(aPopupOpenClasses[1]);
                if (!window.isInitializedRecaptchaSignIn) {
                    console.log('Initializing recaptcha');

                    window.grecaptcha.render('grecaptcha-sign-up', {
                        'sitekey': $('#grecaptcha-sign-up').data('sitekey'),
                        'callback': function (token) {
                            // return new Promise(function (resolve) {
                            return new Promise(function () {
                                base.recaptchaCallback(token, $(btn), base.jxComplete);
                            });
                        },
                        'size': 'invisible'
                    });

                    window.isInitializedRecaptchaSignIn = true;
                } else {
                    console.log('Reset recaptcha');
                    window.grecaptcha.reset();
                }

                return (false);
            }
        );

        $('.btn-login-popup').click(
            function () {
                $('body').removeClass(sPopupOpenClasses);
                $('body').addClass(aPopupOpenClasses[0]);
                $('.form-wrapper.email > .error-message').text('');
                $('.form-wrapper.password > .error-message').text('');

                return (false);
            }
        );

        $('.link-lostpass').click(
            function () {
                $('body').removeClass(sPopupOpenClasses);
                $('body').addClass(aPopupOpenClasses[2]);

                return (false);
            }
        );

        $('.social-share--mail').click(
            function () {
                $('body').removeClass(sPopupOpenClasses);
                $('body').addClass(aPopupOpenClasses[3]);
                $('body').addClass('popup-open');
                $('#share-friend > .btn-wrapper > p').remove();
                $('#share-friend').find('[type="submit"]')
                    .show();

                return (false);
            }
        );

        $('.social-share--link').click(
            function () {
                let toDisable = $('#copy-clipboard').find('[type="submit"]');

                $('body').removeClass(sPopupOpenClasses);
                $('body').addClass(aPopupOpenClasses[4]);
                $('body').addClass('popup-open');
                $('#copy-clipboard > .btn-wrapper > p').remove();
                toDisable.show();

                return (false);
            }
        );

        $('.popup--close').on(
            'click',
            function () {
                $('body').removeClass('popup-open ' + sPopupOpenClasses);
                $('[data-state="clicked"]').attr('data-state', 'initial');

                if ($('body').hasClass('popup-pageSupporter-open')) {
                    $('body').removeClass('popup-open popup-pageSupporter-open');
                }

                return (false);
            }
        );

        /**
         * Smooth Scroll
         */
        $('a[href^="#"]').on('click', function (e) {
            e.preventDefault();

            self.buildSmoothScroll(this.hash, this);
        });

        if (location.hash) {
            self.buildSmoothScroll(location.hash, false);
        }

        /**
        * Active and desactive menu
        */
        $('.active-menu').each(function () {
            let $parent = $(this);

            $parent.find('a[href^="#"]').on('click', function () {
                $parent.find('a[href^="#"]').each(function () {
                    $(this).removeClass('active');
                });
                $(this).addClass('active');
            });
        });

        /**
         * Scrollspy
         */
        if ($('.scrollSpy-nav a').length > 0) {
            let scrollSpy = new Gumshoe('.scrollSpy-nav a',
                {
                    offset: 140,
                    reflow: true
                }
            );

            console.log('scrollspy', scrollSpy);
        }

        /**
         * Owl carousel
         */
        if ($('.carousel--members').length > 0) {
            // console.log('.carousel--members');
            $('.carousel--members').owlCarousel({
                nav: true,
                dots: false,
                navText: ['<i class="fedoraicon fi-chevron-left"></i>', '<i class="fedoraicon fi-chevron-right"></i>'],
                navContainer: '.section--platform-members .carousel-nav',
                loop: true,
                autoplay: true,
                autoplayTimeout: 2000,
                autoplayHoverPause: true,
                responsive: {
                    0: { items: 1 },
                    768: { items: 2 },
                    1024: { items: 4 }
                }
            });
        }

        if ($('.carousel--news').length > 0) {
            let carousel = $('.carousel--news');
            let dotsEach = Math.ceil(carousel.find('.item').length / 7);

            $('.carousel--news').owlCarousel({
                nav: true,
                dots: true,
                dotsEach: dotsEach,
                navText: ['<i class="fedoraicon fi-chevron-left"></i>', '<i class="fedoraicon fi-chevron-right"></i>'],
                navContainer: '.section-list--list .carousel-nav',
                responsive: { 0: { items: 1 } }
            });
        }
        if ($('.shortlist--carousel').length > 0) {
            $('.shortlist--carousel').each(function () {
                let $carousel = $(this);
                let $shortlist = $carousel.parents('.section--shortlist').eq(0);
                let $shortlistInfo = $('.section--shortlist--info', $shortlist);
                let autoplayTimeout = 5000;
                let dotsEach = Math.ceil($carousel.find('.item').length / 7);

                console.log('dotsEach:', dotsEach);
                if ($carousel.data('autoplay-timeout') !== undefined) {
                    autoplayTimeout = $carousel.data('autoplay-timeout');
                }

                $carousel.data('round', '0');

                $carousel.on('initialized.owl.carousel', function (event) {
                    let $currentItem = $('.owl-item', $carousel).eq(event.item.index);

                    $shortlistInfo.html($('.item-desc', $currentItem).html());
                });

                let activeCategory = function (slide) {
                    let header = $('.section-list--header-shortlist');
                    let category = slide.data('category');
                    let selector = 'header-shortlist--' + category;

                    header.each(
                        function (index, item) {
                            if ($(item).hasClass(selector)) {
                                $(item).show();
                            } else {
                                $(item).hide();
                            }
                        }
                    );
                };

                let colorIndex = function (event) {
                    let carousel = $('.owl-dot span', event.target).css({ background: '' });
                    let itemActive = $('.owl-dot.active span', event.target);
                    let activeSlide = $(event.target).find('.owl-item .item');
                    let slide = $(activeSlide[event.item.index]);
                    let activeColor = slide.data('color');

                    carousel.css({ background: '' });
                    itemActive.css({ background: '#' + activeColor });
                    activeCategory(slide);
                };

                function removeAutoPlay () {
                    $carousel.data('owl.carousel').options.autoplay = false;
                    $carousel.trigger('refresh.owl.carousel');
                }

                $carousel.owlCarousel({
                    items: 1,
                    nav: true,
                    margin: 34,
                    dots: true,
                    navText: ['<i class="fedoraicon fi-chevron-left"></i>', '<i class="fedoraicon fi-chevron-right"></i>'],
                    navContainer: $('.carousel-nav', $shortlist),
                    onInitialized: function (event) {
                        let activeSlide = $(event.target).find('.owl-item .item');
                        let activeColor = $(activeSlide[event.item.index]).data('color');

                        $('.owl-dot span', event.target).hover(
                            function () {
                                $(this).css({ background: '#' + activeColor });
                            },
                            function () {
                                if (!$(this).parent()
                                    .hasClass('active')) {
                                    $(this).css({ background: '' });
                                }
                            }
                        );
                        colorIndex(event);
                    },
                    dotsEach: dotsEach,
                    onChanged: colorIndex,
                    rewind: true,
                    autoplay: true,
                    autoplayTimeout: autoplayTimeout,
                    autoplayHoverPause: true,
                    onDrag: removeAutoPlay
                });

                $shortlist.find('.shortlist--carousel-outer button').click(removeAutoPlay);

                $carousel.on('translated.owl.carousel', function (event) {
                    let $currentItem = $('.owl-item.active', $carousel);

                    $shortlistInfo.html($('.item-desc', $currentItem).html());

                    // console.log(event.item.index, event.page.count);

                    if (event.item.index === (event.page.count - 1)) {
                        if ($carousel.data('round') === '0') {
                            $carousel.data('round', '1');
                            console.log($carousel.data('round'));
                        } else {
                            $carousel.trigger('stop.owl.autoplay');
                            let carousel = $carousel.data('owl.carousel');

                            carousel.settings.autoplay = false;
                            carousel.options.autoplay = false;
                            $carousel.trigger('refresh.owl.carousel');
                        }
                    }
                });

                $('.carousel-nav > div', $shortlist).on('click', function () {
                    $carousel.trigger('stop.owl.autoplay');
                    let carousel = $carousel.data('owl.carousel');

                    carousel.settings.autoplay = false;
                    carousel.options.autoplay = false;
                    $carousel.trigger('refresh.owl.carousel');
                });
            });
        }
        if ($('.section--carousel--full').length > 0) {
            let $fullWCarouselWrapper = $('.section--carousel--full');
            let $fullCarousel = $('.fullw--carousel', $fullWCarouselWrapper);

            $fullCarousel.owlCarousel({
                items: 1,
                loop: true,
                nav: true,
                margin: 30,
                dots: true,
                navText: ['<i class="fedoraicon fi-chevron-left"></i>', '<i class="fedoraicon fi-chevron-right"></i>'],
                navContainer: $('.carousel-nav', $fullWCarouselWrapper)
            });

            $fullCarousel.on('translated.owl.carousel', function () {
                let $currentDot = $('.owl-dot.active span', $fullWCarouselWrapper);

                $('.owl-dot span', $fullWCarouselWrapper).css('background-color', '');
                $currentDot.css('background-color', $(this).attr('dot-color'));
            });

            $('.owl-dot span', $fullWCarouselWrapper).eq(0)
                .css('background-color', $fullCarousel.attr('dot-color'));

            $('.owl-dot', $fullWCarouselWrapper).hover(function () {
                // console.log('hover');
                $(this).find('span')
                    .css('background-color', $fullCarousel.attr('dot-color'));
            }, function () {
                if (!$(this).is('.active')) {
                    $(this).find('span')
                        .css('background-color', '');
                }
            });
        }

        /**
         * Filter Dropdown
         */
        if ($('.filter-wrapper').length > 0) {
            $('.filter-list-title').click(function () {
                $(this).children('.fi-chevron-up')
                    .toggleClass('rotate');
                $(this).next('.form-checkbox-wrapper')
                    .slideToggle();
            });

            let firstCheckboxWrapper = $('.form-checkbox-wrapper').first();

            firstCheckboxWrapper.show();

            $('.form-checkbox-wrapper:not(:first)').each(function () {
                let isChecked = $(this).find('input[type="checkbox"]')
                    .is(':checked');

                if (isChecked) {
                    $(this).show();
                    $(this).siblings('.filter-list-title')
                        .children('.fi-chevron-up')
                        .toggleClass('rotate');
                } else {
                    $(this).hide();
                }
            });
        }

        /**
         * Reset Filter
         */
        if ($('.filter-wrapper').length > 0) {
            $('#reset-filter').click(function () {
                $(".filter-list input[type='checkbox']").each(function () {
                    $(this).prop('checked', false);
                });
            });
        }

        /**
         * Competition history accordion
         */
        if ($('.competition--list').length > 0) {
            $('.competition--list--item--header').click(function () {
                // Remove active class from all headers
                $('.competition--list--item--header').not(this)
                    .removeClass('active');

                // Toggle active class for the clicked header
                $(this).toggleClass('active');

                // Toggle rotate class for the fedoraicon
                $(this).children('.fedoraicon')
                    .toggleClass('rotate');

                // Slide toggle the content
                $(this).next('.competition--list--item--content')
                    .slideToggle();

                if ($(this).hasClass('active')) {
                    handleSectionClick($(this).attr('data-url'), $(this).attr('data-year'), true);
                }
            });

            $('.competition--list--item--content').each(function () {
                const $fedoraPrize = $(this).find('a.btn')
                    .first();
                const $nextStage = $(this).find('a.btn:nth-child(2)');

                $fedoraPrize.click(function () {
                    $(this).addClass('active btn-black');
                    $nextStage.removeClass('active btn-black').addClass('btn-default');
                    $(this).closest('.cta-btn')
                        .siblings('.competition-project')
                        .children('#nexstage-award')
                        .addClass('hidden');
                    $(this).closest('.cta-btn')
                        .siblings('.competition-project')
                        .children('#fedora-award')
                        .removeClass('hidden');
                    // console.log('In fedoraPrize:');
                    handleSectionClick($(this).attr('data-url'), $(this).attr('data-year'));
                });

                $nextStage.click(function () {
                    $(this).addClass('active btn-black');
                    $fedoraPrize.removeClass('active btn-black').addClass('btn-default');
                    $(this).closest('.cta-btn')
                        .siblings('.competition-project')
                        .children('#fedora-award')
                        .addClass('hidden');
                    $(this).closest('.cta-btn')
                        .siblings('.competition-project')
                        .children('#nexstage-award')
                        .removeClass('hidden');
                    // console.log('In nextStage:');
                    handleSectionClick($(this).attr('data-url'), $(this).attr('data-year'));
                });
            });
        }

        /**
         * Tabs Project
         */
        if ($('.section--projects').length > 0) {
            const urlParams = new URLSearchParams(window.location.search);
            let activeTab = urlParams.get('tab');

            if (!activeTab) {
                activeTab = $('.link-tab.active').data('tab');
            }

            $('.link-tab').click(function (e) {
                e.preventDefault();
                $('html, body').stop();

                let targetTab = $(this).attr('href');
                let tabId = $(this).data('tab');

                if (tabId === activeTab) {
                    return;
                }

                $('#filterForm input[name="tab"]').val(tabId);

                showTabContent(targetTab);
                projectMap();

                activeTab = tabId;

                const newParams = new URLSearchParams(window.location.search);

                newParams.set('tab', tabId);

                window.history.replaceState({ path: window.location.pathname }, '', '?' + newParams.toString());
            });

            $('#members-list-select').change(function () {
                const targetTab = $(this).val();

                if (targetTab === 'competition-history') {
                    const competitionHistoryPageUrl = $('[data-competition-url]').data('competition-url');

                    window.location.href = competitionHistoryPageUrl;
                } else {
                    showTabContent(targetTab);
                    projectMap();
                }
            });

            showTabContent(`#${activeTab === 'list-view' ? 'project-list-grid-anchor' : 'project-map-anchor'}`);

            if (activeTab === 'map-view') {
                projectMap();
            }
        }

        /**
         * Mobile tabs project select scroll down
         */
        let scrollExecuted = false;

        function checkAndScroll () {
            if (!scrollExecuted && $(window).width() < 768 && window.location.href.indexOf('filter-') > -1) {
                let $activeTabContent = $('.tab-content.active');

                if ($activeTabContent.length > 0) {
                    $('html, body').animate({ scrollTop: $activeTabContent.offset().top - 75 }, 1000, function () {
                        scrollExecuted = true;
                    });
                }
            }
        }
        checkAndScroll();

        $(window).resize(function () {
            checkAndScroll();
        });

        /**
        * Google Map
        */
        function projectMap () {
            let constantsList = JSON.parse($('#fedora').attr('data-consts'));
            let jxRetrieveMap = null;
            const queryString = window.location.search;

            let map2 = new GMaps({
                el: '#projects-map',
                disableDefaultUI: true,
                lat: constantsList.google_map_lat,
                lng: constantsList.google_map_long,
                zoom: constantsList.google_map_zoom,
                styles: gMapStyle
            });

            map2.removeMarkers();
            if (jxRetrieveMap) {
                jxRetrieveMap.abort();
            }

            let projectsMapEl = $('#projects-map');
            let url = projectsMapEl.attr('data-url');

            if (queryString) {
                url += queryString;
            }

            jxRetrieveMap = $.ajax({
                method: 'get',
                url: url,
                data: { url: url }
            }).done(function (dataObjects) {
                // console.log('dataObjects=', dataObjects);

                dataObjects.forEach(function (data) {
                    let image;

                    if (data.type === 'platform-member') {
                        image = '/images/icon-platform-member.png';
                    } else {
                        image = '/images/icon-member.png';
                    }

                    map2.addMarker({
                        lat: parseFloat(data.latitude),
                        lng: parseFloat(data.longitude),
                        title: data.name,
                        icon: image,
                        infoWindow: { content: data.tooltip }
                    });
                });
            })
                .fail(function () {
                    base.log('Error retrieving member list for map');
                });
        }

        function showTabContent (targetTab) {
            $('.link-tab').removeClass('active');
            $(`.link-tab[href="${targetTab}"]`).addClass('active');

            $('.tab-content').removeClass('active');
            $(targetTab).addClass('active');
        }

        function handleSectionClick (url, year, isHeader = false, nexstageEmpty = false) {
            let jxRetrieveProject = null;

            if (jxRetrieveProject || !url) {
                base.log('Error Still retrieving project from competition history Or data-url is empty');
                jxRetrieveProject.abort();
            }

            nexstageEmpty = false;

            if (isHeader) {
                // Check nexstage if empty
                $.ajax({
                    type: 'GET',
                    url: $('#section-next-stage-' + year).data('url'),
                    success: (response) => {
                        if ($(response.join('')).length === 0) {
                            nexstageEmpty = true;
                        }
                    }
                });
            }

            jxRetrieveProject = $.ajax({
                type: 'GET',
                url: url,
                beforeSend: () => {
                    $('#loader-' + year).removeClass('hidden');
                },
                success: (response) => {
                    let $responseDataElement = $('#competition--year--' + year);
                    let data = $(response.join('')).length > 0 ? $(response.join('')) : `<span class="no-list">No projects found</span>`;

                    if ($responseDataElement.length > 0) {
                        $responseDataElement.html('');
                    }
                    $responseDataElement.append(data);

                    $('#loader-' + year).addClass('hidden');

                    if (isHeader && nexstageEmpty) {
                        $('#section-next-stage-' + year).closest('.cta-btn')
                            .hide();
                    }
                },
                error: (xhr, status, error) => {
                    console.error('competition--prize--list error:', error);

                    $('#loader-' + year).addClass('hidden');
                },
                fail: () => {
                    base.log('Error retrieving project from competition history');

                    $('#loader-' + year).addClass('hidden');
                }
            });
        }

        /**
         * Shortlist
         */
        const bgImageBaseWidth = 1280;
        const animDuration = 1;
        const animStagDuration = 0.1;
        const overwriteMode = 0;
        const animPadding = 10;
        const shortListHeaderMenuElements = $('.shortlist--header-menu');
        const defaultIndexImg = 1;
        const bgDecalageX = 50;
        const bgMappingByDataLabel = [
            {
                id: 'dance',
                indexImg: 0,
                endPosX: -162,
                startPosX: 0,
                startPosY: -220
            },
            {
                id: 'opera',
                indexImg: 2,
                endPosX: -560,
                startPosX: 0,
                startPosY: 0
            },
            {
                id: 'education',
                indexImg: 3,
                endPosX: -760,
                startPosX: 0,
                startPosY: -445
                // startPosY: -576
            }
        ];
        let maskAnimDelay = 0;
        let allBgImageButDefault;
        let animInnerWidth;
        let animStartPosX;
        let animStartOffset;
        let animContainerWidth;
        let animContainerMask;
        let anim;
        let background;
        let backgroundContainer = $('.shortlist--header--bg-anim .background')[0];
        let canTween = false;
        let loaded = 0;
        let bgImageRatio = 1;
        let listStartPosX = []; // List of { prize: 'education', x: 345, imgStartX: null, imgEndX: null }

        function gotoShortlist (_prizeSlug) {
            if (_prizeSlug !== undefined) {
                if (location.hash !== '#' + _prizeSlug) {
                    location.hash = _prizeSlug;
                }

                let prizeColor = $('.shortlist--header-menu[data-prize=' + _prizeSlug + ']').data('color');
                let prizeSubTitle = $('.shortlist--header-menu[data-prize=' + _prizeSlug + ']').data('subtitle');

                $('.shortlist-content--header').css('background-color', '#' + prizeColor);
                $('.shortlist-content--list h2').css('background-color', '#' + prizeColor);
                $('.shortlist-content--list h2').text(prizeSubTitle);

                $('.list--grid--item').parent()
                    .hide();

                $('.list--grid--item[data-prize=' + _prizeSlug + ']').parent()
                    .show();
            } else {
                location.hash = 'all';

                $('.shortlist-content--header').css('background-color', '');
                $('.shortlist-content--list h2').css('background-color', '');
                $('.list--grid--item').parent()
                    .show();
            }
        }

        function setAnimPropertiesForShortlistPrize () {
            if (shortListHeaderMenuElements.length > 0) {
                let animOffset;
                let hasMoreThan3Prize = $('.fedora-f-container').length > 0;
                let greyFY = 0;
                // let heightF = 0;
                let bigContainerH;

                animContainerMask = $('.shortlist--header--bg-anim .container .mask');
                animContainerWidth = animContainerMask.width();
                animInnerWidth = $('.shortlist--header--bg-anim .outer .inner').width();
                animStartPosX = (animContainerWidth / 2 - animInnerWidth / 2) + 5;
                animOffset = animContainerMask.offset();
                animStartOffset = {
                    left: animOffset.left + animStartPosX,
                    top: animOffset.top
                };

                bgImageRatio = background.eq(0).width() / bgImageBaseWidth;
                TweenMax.set(
                    anim,
                    { x: animStartPosX }
                );
                // For 2020 ...
                listStartPosX = [];
                shortListHeaderMenuElements.each(function () {
                    let fedoraFcontainer = $(this).find('.fedora-f-container');
                    let fedoraFel = $(this).find('.fedora-f');
                    let elW;
                    let startX;
                    let imgStartX;
                    let imgEndX;
                    let imgPosY;
                    let imgW;
                    let categorie;
                    let imgEl;

                    // ... Set size of bg frame for each item
                    if (fedoraFcontainer.length > 0) {
                        // elW = Math.floor($(fedoraFcontainer).width());
                        elW = Math.floor($('.section--title').width() + (window.innerHeight * 0.05));
                        startX = elW + 5;
                        fedoraFel = fedoraFel[0];
                        categorie = $(this).data('prize') || $(this).data('nominee');
                        imgEl = $(this).find('.images-container img');
                        $(fedoraFel).width(elW);
                        $(fedoraFel).height(elW);
                        // let heightF = elW;

                        // ... Save start point for use in rollover
                        if ($(fedoraFcontainer).offset().left < window.innerWidth / 2) {
                            startX = startX * -1;
                        }

                        // Background image position
                        switch (categorie) {
                            case 'education':
                                imgPosY = -46;
                                imgStartX = -15;
                                imgEndX = -26;
                                imgW = null;
                                break;
                            case 'dance':
                                imgPosY = -50;
                                imgStartX = -15;
                                imgEndX = -25;
                                imgW = null;
                                break;
                            case 'opera':
                                imgPosY = -1;
                                imgStartX = -15;
                                imgEndX = -50;
                                imgW = '180%';
                                break;
                            case 'digital':
                                imgPosY = -43;
                                imgStartX = -35;
                                imgEndX = -50;
                                break;
                        }

                        TweenMax.set(
                            imgEl,
                            {
                                xPercent: imgStartX,
                                yPercent: imgPosY
                            }
                        );

                        if (imgW) {
                            TweenMax.set(
                                imgEl,
                                { width: imgW }
                            );
                        }

                        listStartPosX.push(
                            {
                                prize: categorie,
                                x: startX,
                                imgStartX: imgStartX,
                                imgEndX: imgEndX,
                                imgPosY: imgPosY
                            }
                        );
                    }
                });

                if (hasMoreThan3Prize) {
                    greyFY = $('.shortlist--header--menu-wrapper').offset().top;
                    greyFY = greyFY + $('.shortlist--header--menu-wrapper').height() / 2;
                    greyFY = greyFY - $('.shortlist--header--bg-anim').height() / 2;
                    $('.shortlist--header--bg-anim').css({ top: greyFY });

                    // Height of main container
                    bigContainerH = $('.shortlist--header--menu-wrapper').offset().top + $('.shortlist--header--menu-wrapper').height();
                    console.log('methode setAnimPropertiesForShortlistPrize > bigContainerH: ', bigContainerH);
                    $('.header--shortlist').height(bigContainerH);
                }
            }
        }

        function getTargetBackgroundObj (dataId) {
            for (const item of bgMappingByDataLabel) {
                if (item.id === dataId) {
                    return item;
                }
            }
            console.log('');

            return bgMappingByDataLabel[0];
        }

        if (shortListHeaderMenuElements.length > 0) {
            anim = $('.shortlist--header--bg-anim .outer');
            background = $('.shortlist--header--bg-anim .background img');
            allBgImageButDefault = [];
            background.each(
                function (index, imgEl) {
                    if (index !== defaultIndexImg) {
                        allBgImageButDefault.push(imgEl);
                    }
                    $(this).on(
                        'load',
                        () => {
                            ++loaded;
                            if (loaded === background.length) {
                                canTween = true;
                                $('.shortlist--header--bg-anim .background').addClass('ready');
                            }
                        }
                    );
                }
            );

            // Hide F
            shortListHeaderMenuElements.each(function () {
                let fedoraFel = $(this).find('.fedora-f-container');
                let fedoraFelInner = $(this).find('.fedora-f');
                let fedoraMasks = $(this).find('.mask-item');

                if (fedoraFel) {
                    TweenMax.set(
                        fedoraFel,
                        { autoAlpha: 0 }
                    );

                    TweenMax.set(
                        fedoraMasks,
                        { x: $(fedoraFelInner).width() }
                    );
                }
            });

            setAnimPropertiesForShortlistPrize();

            TweenMax.set(
                anim,
                { x: animStartPosX }
            );
            TweenMax.set(
                background,
                {
                    alpha: 0,
                    x: 0
                }
            );
            TweenMax.set(
                background.eq(defaultIndexImg),
                { alpha: 1 }
            );

            shortListHeaderMenuElements.click(
                function () {
                    let data = $(this).data();

                    if (data && data.prize) {
                        $('body').addClass('shortlist-open');
                        gotoShortlist(data.prize);
                    }
                }
            );

            $('.link--back-shortlist').click(
                function () {
                    $('body').removeClass('shortlist-open');
                    gotoShortlist();
                }
            );

            // Hover on desktop app only
            if ($('body').hasClass('desktop-app')) {
                shortListHeaderMenuElements.hover(
                    function () {
                        const $wrapper = $(this).parents('.shortlist--header--menu-wrapper');
                        const data = $(this).data('prize') || $(this).data('nominee');
                        const thisOffset = $(this).offset();
                        const animDistanceToMove = thisOffset.left - animStartOffset.left;
                        const bgImg = $(this).find('.images-container img');
                        let targetBackgroundObj = getTargetBackgroundObj(data);
                        let targetPosition = (animStartPosX + animDistanceToMove) - animPadding;
                        let targetBgPosition = targetPosition + (targetBackgroundObj.endPosX * bgImageRatio);
                        let maskItems = $(this).find('.mask-item');
                        let fedoraFcontainer = $(this).find('.fedora-f-container');
                        let params = null;

                        targetBackgroundObj.startPosX = animDistanceToMove > 0 ? targetBgPosition + bgDecalageX : targetBgPosition - bgDecalageX;
                        $wrapper.eq(0).addClass(data);

                        if (canTween) {
                            // We show background if we have less or equal to 3 prizes
                            if (!isPrizeMoreThanThree) {
                                TweenMax.to(
                                    background.eq(defaultIndexImg),
                                    animDuration,
                                    {
                                        alpha: 0,
                                        ease: Back.easeInOut.config(0.2)
                                    }
                                );

                                TweenMax.set(
                                    background.eq(targetBackgroundObj.indexImg),
                                    {
                                        x: targetBackgroundObj.startPosX,
                                        y: targetBackgroundObj.startPosY * bgImageRatio
                                    }
                                );

                                TweenMax.to(
                                    background.eq(targetBackgroundObj.indexImg),
                                    animDuration,
                                    {
                                        alpha: 1,
                                        delay: 0.2,
                                        x: targetBgPosition,
                                        ease: Back.easeInOut.config(0.2)
                                    }
                                );
                            } else {
                                targetPosition = (animStartPosX - animDistanceToMove) - animPadding;
                                // Set params for bg animation
                                for (let item in listStartPosX) {
                                    if (data === listStartPosX[item].prize) {
                                        params = listStartPosX[item];
                                        break;
                                    }
                                }

                                TweenMax.to(
                                    backgroundContainer,
                                    animDuration,
                                    {
                                        alpha: 0,
                                        ease: Back.easeInOut.config(0.2)
                                    }
                                );

                                // Animate bg imgStartX: null, imgEndX
                                TweenMax.to(
                                    bgImg,
                                    animDuration,
                                    {
                                        xPercent: params.imgEndX,
                                        yPercent: params.imgPosY,
                                        ease: Back.easeInOut.config(0.2)
                                    }
                                );

                                TweenMax.to(
                                    fedoraFcontainer,
                                    0.15,
                                    { autoAlpha: 1 }
                                );

                                TweenMax.staggerTo(
                                    maskItems,
                                    animDuration,
                                    {
                                        x: 0,
                                        ease: Back.easeInOut.config(0.2)
                                    },
                                    animStagDuration
                                );
                            }

                            TweenMax.staggerTo(
                                anim,
                                animDuration,
                                {
                                    x: targetPosition,
                                    overwrite: overwriteMode,
                                    ease: Back.easeInOut.config(0.2)
                                },
                                animStagDuration
                            );
                        }
                    },
                    function () {
                        const $wrapper = $(this).parents('.shortlist--header--menu-wrapper');
                        const data = $(this).data('prize') || $(this).data('nominee');
                        const bgImg = $(this).find('.images-container img');
                        let targetBackgroundObj = getTargetBackgroundObj(data);
                        let innerMaskStartX = 0;
                        let maskItems = $(this).find('.mask-item');
                        let fedoraFcontainer = $(this).find('.fedora-f-container');
                        let params = null;

                        $wrapper.eq(0).removeClass(data);

                        if (canTween) {
                            if (!isPrizeMoreThanThree) {
                                TweenMax.to(
                                    background.eq(defaultIndexImg),
                                    animDuration,
                                    {
                                        alpha: 1,
                                        ease: Back.easeInOut.config(0.2)
                                    }
                                );

                                TweenMax.to(
                                    background.eq(targetBackgroundObj.indexImg),
                                    animDuration,
                                    {
                                        delay: 0.2,
                                        x: targetBackgroundObj.startPosX * bgImageRatio,
                                        ease: Back.easeInOut.config(0.2)
                                    }
                                );

                                TweenMax.to(
                                    allBgImageButDefault,
                                    animDuration,
                                    {
                                        alpha: 0,
                                        delay: 0.2,
                                        ease: Back.easeInOut.config(0.2)
                                    }
                                );
                            } else {
                                // maskAnimDelay = animDuration;
                                TweenMax.to(
                                    backgroundContainer,
                                    animDuration,
                                    {
                                        alpha: 1,
                                        ease: Back.easeInOut.config(0.2)
                                    }
                                );

                                // Set start point
                                for (let item in listStartPosX) {
                                    if (data === listStartPosX[item].prize) {
                                        innerMaskStartX = listStartPosX[item].x;
                                        break;
                                    }
                                }

                                // Set params for bg animation
                                for (let item in listStartPosX) {
                                    if (data === listStartPosX[item].prize) {
                                        params = listStartPosX[item];
                                        break;
                                    }
                                }

                                // Animate bg
                                TweenMax.to(
                                    bgImg,
                                    animDuration,
                                    {
                                        xPercent: params.imgStartX,
                                        yPercent: params.imgPosY,
                                        ease: Back.easeInOut.config(0.2)
                                    }
                                );

                                TweenMax.staggerTo(
                                    maskItems,
                                    animDuration,
                                    {
                                        x: innerMaskStartX,
                                        ease: Back.easeInOut.config(0.8),
                                        onComplete: function () {
                                            TweenMax.to(
                                                fedoraFcontainer,
                                                0.15,
                                                { autoAlpha: 0 }
                                            );
                                        }
                                    },
                                    animStagDuration
                                );
                            }

                            TweenMax.staggerTo(
                                anim,
                                animDuration,
                                {
                                    x: animStartPosX,
                                    ease: Back.easeInOut.config(0.8),
                                    delay: maskAnimDelay
                                },
                                animStagDuration
                            );
                        }
                    }
                );
            }

            if (window.location.hash) {
                let prize = window.location.hash.substr(1);
                let prizesList = [];

                $('.shortlist--header-menu').each(function () {
                    prizesList.push($(this).data('prize'));
                });

                if (prize && $.inArray(prize, prizesList) > -1 && $('#shortlist-content').length > 0) {
                    gotoShortlist(prize);
                }
            }
        }

        /**
         * Countdown Function
         */
        function countdownFunc () {
            let constantsList = JSON.parse($('#fedora').attr('data-consts'));
            const timer = window.countDown;

            $('.countdown--counter').each(function () {
                const toDate = new Date($('.countdown--counter').attr('data-timestamp') * 1000);
                let labelsItem = $(window).width() < 768 ? 'D,H,M,S' : $('.countdown--counter').attr('data-labels');
                const labels = labelsItem.split(',');
                let timeMarkup = '';
                let nowDate = null;

                if (typeof $('.countdown--counter').data('now') === 'undefined') {
                    $('.countdown--counter').data('now', constantsList.now);
                } else {
                    $('.countdown--counter').data('now', $('.countdown--counter').data('now') + 1);
                }
                nowDate = new Date($('.countdown--counter').data('now') * 1000);

                // console.log($('.countdown--counter').data('now'), toDate, nowDate);

                if (toDate > nowDate) {
                    let timeSpan = countdown(toDate, nowDate, countdown.DAYS | countdown.HOURS | countdown.MINUTES | countdown.SECONDS);

                    timeMarkup += '<span class="number">' + ((timeSpan.days > 9) ? timeSpan.days : '0' + timeSpan.days) + '</span>' + labels[0];
                    timeMarkup += '<span class="number">' + ((timeSpan.hours > 9) ? timeSpan.hours : '0' + timeSpan.hours) + '</span>' + labels[1];
                    timeMarkup += '<span class="number">' + ((timeSpan.minutes > 9) ? timeSpan.minutes : '0' + timeSpan.minutes) + '</span>' + labels[2];
                    timeMarkup += '<span class="number">' + ((timeSpan.seconds > 9) ? timeSpan.seconds : '0' + timeSpan.seconds) + '</span>' + labels[3];

                    $(this).html(timeMarkup);
                } else {
                    $(this).remove('.countdown--counter');

                    /* if ($(this).parent()
                        .find('.countdown--title').length > 0) {
                        $(this).parent()
                            .find('.countdown--title')
                            .html($('.countdown--counter').attr('data-content-end'));
                        $(this).html('');
                    } else {
                        $(this).html('<span class="number">' + $('.countdown--counter').attr('data-content-end') + '</span>');
                    } */

                    clearInterval(timer);
                }
            });
        }

        if ($('.countdown--counter').length > 0) {
            countdownFunc();
            window.countDown = setInterval(countdownFunc, 1000);
        }

        /**
         * Buton Go To First Carousel
         */
        if ($('.goto-first-carousel').length > 0) {
            let $carousels = $('.section-list--header-outer');

            if ($carousels.length > 0) {
                $('.goto-first-carousel').unbind('click')
                    .on('click', function () {
                        let $firstCarousel = $($carousels[0]);

                        $('html, body').stop()
                            .animate({ 'scrollTop': $firstCarousel.offset().top - $('.main-menu').outerHeight() }, 600, 'swing');
                    });
            }
        }

        /**
         * Page dispatch
         */
        if ($('body').hasClass('members')) {
            this.initializeMembers();
        }

        /**
        * Initialize User handles
        */
        if ($('#popup--login').hasClass('loggeable')) {
            this.userHandlers();
        }
        /**
        * Initialize Signup
        */
        if ($('#popup--signup').hasClass('registrable')) {
            this.registerHandlers();
        }

        /*
        * Vote handlers
        */
        if ($('body').has('is--logged')) {
            this.voteHandlers();
        }

        /*
        * Newsletters
        */
        // if ($('body').has('register-newsletter')) {
        //     this.newsletterHandlers();
        // }

        /**
        * Social sharer
        */
        if ($('body').has('social-sharer')) {
            this.socialSharer();
        }

        if ($('body').hasClass('news-list')) {
            this.newsList();
        }

        if ($('body').hasClass('artists-list')) {
            this.artistsList();
        }

        if ($('body').hasClass('projects-list')) {
            this.projectsList();
        }

        /**
         * Sections Replace
         */
        if ($('.switch-content').length) {
            $('.switch-action').click(function () {
                if ($(this).attr('data-target')) {
                    $('#' + $(this).attr('data-target')).children()
                        .eq(0)
                        .hide();
                    $('#' + $(this).attr('data-target')).children()
                        .eq(1)
                        .show();
                }
            });
        }

        if ($('.display-action').length) {
            $('.display-action').click(function () {
                if ($(this).attr('data-target')) {
                    $(this).hide();
                    $('#' + $(this).attr('data-target')).show();
                }
            });
        }

        /**
         * Buton Go To First Carousel
         */
        if ($('.scroll-to-counterpart-list').length > 0) {
            let $counterPartList = $('#counterparts-list');

            $('.scroll-to-counterpart-list').unbind('click')
                .on('click', function () {
                    $('html, body').stop()
                        .animate({ 'scrollTop': $counterPartList.offset().top - $('.main-menu').outerHeight() }, 600, 'swing');
                });
        }

        /**
         * Counterpart anchor
         */
        if ($('body').hasClass('counterparts')) {
            let currentHash = window.location.hash;
            let $counterPartList = $('#counterparts-list');
            let base = this;

            base.jxComplete = {};

            if (currentHash === '#counterparts') {
                let interval = setInterval(function () {
                    $('html, body').stop()
                        .animate({ 'scrollTop': $counterPartList.offset().top - $('.main-menu').outerHeight() }, 600, 'swing');
                    clearInterval(interval);
                }, 500);
            }

            if ($('#amount').length > 0) {
                base.donationAmount = $('#amount').val();
                if ($('#counterPartId').length > 0) {
                    base.donationCounterPart = $('#counterPartId').val();
                }

                // let checkCompleteFields = $('#check-informations-complete').val();
            }
        }

        /**
         * Target _blank on links inside project RTE
         */
        $('.project--content .project--content--rte a, .project--content .project--content--artist a, .project--content .project--content--counterparts a, .project--content .counterpart--inner .content a').attr('target', '_blank');

        /**
         * Show fixed bar only on scroll on --not-medium devices
         */
        if ($('.section--project--detail .shortlist-content--header').length > 0) {
            let $footerHeader = $('.section--project--detail .shortlist-content--header');
            let scrollPos = window.pageYOffset;

            $(window).scroll(function () {
                if (window.pageYOffset !== scrollPos) {
                    $footerHeader.css('bottom', '0px');
                }
            });
        }

        /**
         * Show registred popup
         */
        if ($('#popup--registred').length > 0) {
            $('body').removeClass(this.formatedPopupClasses());
            $('body').addClass('popup-open popup-registred-open');
        }

        /**
         * Delete my account
         */
        this.initializeDeleteAccount();

        /**
         * Remove error when input change
         */
        $('input, textarea').change(function () {
            let $nextElt = $(this).next();

            if ($nextElt.length === 0) {
                $nextElt = $(this).parent()
                    .next();
            }

            if ($nextElt.hasClass('error-message')) {
                $nextElt.html('');
            }
        });

        /**
         * ** Memberships
        */
        function clearMsgDonationAfter () {
            $('#free_donation_label')
                .hide();
            $('[name="category"]').next()
                .next()
                .hide();
            $('.toggle-donation-label').hide();
        }

        function showCreateAccount (el = false) {
            if (!el) {
                el = $('[name=create_account]');
            }
            if (el.is(':checked')) {
                $('.accout_data').show();
            } else {
                $('.accout_data').hide();
            }
        }

        setInterval(function () {
            showCreateAccount();
        }, 300);

        function handlePosition (typeSubscription) {
            if (typeSubscription === 4) {
                $('#individual-position').children()
                    .detach()
                    .appendTo('#free-donation-position');
            } else if (typeSubscription === 2) {
                $('#free-donation-position').children()
                    .detach()
                    .appendTo('#individual-position');
            }
        }

        function donationValueHandler () {
            let form = $('#free_donation');

            if (form) {
                let radio = form.find('input[name="free_donation_defined"]');
                let input = form.find('input[name="free_donation"]');

                radio.on(
                    'change',
                    function () {
                        if (this.value) {
                            input.val('');
                        }
                    }
                );

                input.on(
                    'input',
                    function () {
                        if (this.value !== 0) {
                            radio.prop('checked', false);
                        }
                    }
                );
            }
        }

        function organisation () {
            clearMsgDonationAfter();
            $('[data-behavior~=member-type-title]').html('Organisational Member Registration');
            // $('[data-behavior~=create_account_label]').html('Please check if you wish to use your Key Contact information to create an account.');

            document.title = 'Membership Registration';
            $('.section--content p.text').html('Membership Registration');

            $('.menu-list li a').removeClass('active');
            if ($('#type_subscription').val() === 'individual') {
                $('#country_code').insertAfter($('#name_of_organisation'));
                $('#city').insertAfter($('#name_of_organisation'));
                $('#postal_code').insertAfter($('#name_of_organisation'));
                $('#adress').insertAfter($('#name_of_organisation'));
            }
            $('#type_subscription').val('organisational');
            $('#name_of_organisation label').html('Name of the organisation <abbr title="required">*</abbr>');
            $('#representative h2').html('Organisation\'s Representative');
            $('[name="name_of_organisation"]').attr('placeholder', 'Name of the organisation');
            $('#category_organisation').fadeIn('slow');
            $('#genereal_information').fadeIn('slow');
            $('#key_contact_person').fadeIn('slow');
            $('#date_of_birth').fadeOut('slow');
            $('#profession').fadeOut('slow');
            $('#nationality').fadeOut('slow');

            $('[data-behavior~=show-if-organisation]').fadeIn();

            $('#category_individual').fadeOut('slow');
            $('#category_corporate').fadeOut('slow');
            $('#free_donation').fadeOut('slow');
            $('#payement_methode_other').fadeOut('slow');
            $('#billing_adresse').fadeOut('slow');
            $('#benefiting').fadeOut('slow');
            $('#nationality').fadeOut('slow');

            $('[data-behavior~=show-if-corporate]').fadeOut();
            $('[data-behavior~=only-if-make-donation]').fadeOut();
            $('[data-behavior~=hide-if-make-donation]').fadeIn('slow');

            showCreateAccount();
        }
        function individual () {
            clearMsgDonationAfter();
            handlePosition(2);
            $('[data-behavior~=member-type-title]').html('Individual Member Registration');

            $('.menu-list li a').removeClass('active');
            $('#type_subscription').val('individual');
            $('#representative h2').html('Personal Information');

            document.title = 'Membership Registration';
            $('.section--content p.text').html('Membership Registration');

            $('#category_individual').fadeIn('slow');
            $('#free_donation').fadeIn('slow');
            $('#payement_methode_other').fadeIn('slow');
            $('#date_of_birth').fadeIn('slow');
            $('#profession').fadeIn('slow');
            $('#nationality').fadeIn('slow');
            $('#benefiting').fadeIn('slow');

            $('#category_organisation').fadeOut('slow');
            $('#category_corporate').fadeOut('slow');
            $('#genereal_information').fadeOut('slow');
            $('#key_contact_person').fadeOut('slow');

            $('[data-behavior~=show-if-organisation]').fadeOut();
            $('[data-behavior~=show-if-corporate]').fadeOut();
            $('#country_code').insertAfter($('#first_name'));
            $('#city').insertAfter($('#first_name'));
            $('#postal_code').insertAfter($('#first_name'));
            $('#adress').insertAfter($('#first_name'));
            $('#billing_adresse').fadeOut('slow');

            $('[data-behavior~=hide-if-make-donation]').fadeIn('slow');
            $('[data-behavior~=only-if-make-donation]').fadeOut();

            showCreateAccount();
        }
        function corporate () {
            clearMsgDonationAfter();
            $('[data-behavior~=member-type-title]').html('Corporate Member Registration');
            // $('[data-behavior~=create_account_label]').html('Please check if you wish to use your Key Contact information to create an account.');

            document.title = 'Membership Registration';
            $('.section--content p.text').html('Membership Registration');

            $('.menu-list li a').removeClass('active');
            if ($('#type_subscription').val() === 'individual') {
                $('#country_code').insertAfter($('#name_of_organisation'));
                $('#city').insertAfter($('#name_of_organisation'));
                $('#postal_code').insertAfter($('#name_of_organisation'));
                $('#adress').insertAfter($('#name_of_organisation'));
            }
            $('#type_subscription').val('corporate');
            $('#name_of_organisation label').html('Name of the company <abbr title="required">*</abbr>');
            $('[name="name_of_organisation"]').attr('placeholder', 'Name of the company');
            $('#representative h2').html('Company\'s Representaive');

            $('#free_donation').fadeIn('slow');
            $('#category_corporate').fadeIn('slow');
            $('#payement_methode_other').fadeIn('slow');
            $('#genereal_information').fadeIn('slow');
            $('#key_contact_person').fadeIn('slow');
            $('#billing_adresse').fadeIn('slow');
            $('#nationality').fadeIn('slow');
            $('#benefiting').fadeIn('slow');

            $('[data-behavior~=show-if-corporate]').fadeIn();

            $('#category_organisation').fadeOut('slow');
            $('#category_individual').fadeOut('slow');
            $('#date_of_birth').fadeOut('slow');
            $('#profession').fadeOut('slow');

            $('[data-behavior~=show-if-organisation]').fadeOut();
            $('[data-behavior~=only-if-make-donation]').fadeOut();
            $('[data-behavior~=hide-if-make-donation]').fadeIn('slow');
            $('[name=country_code]').val('');

            $('#name_of_organisation_billing').fadeOut('slow');
            $('#adress_billing').fadeOut('slow');
            $('#postal_code_billing').fadeOut('slow');
            $('#city_billing').fadeOut('slow');
            $('#country_code_billing').fadeOut('slow');

            showCreateAccount();
        }

        function makeDonation () {
            clearMsgDonationAfter();
            handlePosition(4);
            $('[data-behavior~=member-type-title]').html('Make a Donation');

            $('.menu-list li a').removeClass('active');
            $('#type_subscription').val('free-donation');
            $('#representative h2').html('Personal Information');
            $('#free_donation h2').html('Make a Donation');
            $('#donation-prefix').html('Other amount €');

            if ($('.free-donation-template').length === 0) {
                document.title = 'Join & Support';
                $('.section--content p.text').html('Join & Support');
            }

            $('#category_individual').fadeIn('slow');
            $('#free_donation').fadeIn('slow');
            $('#payement_methode_other').fadeIn('slow');
            $('#date_of_birth').fadeIn('slow');
            $('#profession').fadeIn('slow');
            $('#nationality').fadeIn('slow');
            $('#benefiting').fadeIn('slow');

            $('#category_organisation').fadeOut('slow');
            $('#category_corporate').fadeOut('slow');
            $('#genereal_information').fadeOut('slow');
            $('#key_contact_person').fadeOut('slow');

            $('[data-behavior~=show-if-organisation]').fadeOut();
            $('[data-behavior~=show-if-corporate]').fadeOut();

            if ($('.free-donation-template').length === 0) {
                $('#country_code').insertAfter($('#first_name'));
                $('#city').insertAfter($('#first_name'));
                $('#postal_code').insertAfter($('#first_name'));
                $('#adress').insertAfter($('#first_name'));
            }

            $('#billing_adresse').fadeOut('slow');

            $('[data-behavior~=hide-if-make-donation]').fadeOut();
            $('[data-behavior~=only-if-make-donation]').fadeIn('slow');

            showCreateAccount();
            showDonationAfterFrenchTax();
            showDonationAfterFrenchTaxFree();
        }

        $('[name="create_account"]').change(function () {
            showCreateAccount($(this));
        });

        $('[name="country_code"]').change(function () {
            console.log('ETO');
            clearMsgDonationAfter();
            showDonationAfterFrenchTax();
            showDonationAfterFrenchTaxFree();
        });

        $('[name="country_code_billing"]').change(function () {
            clearMsgDonationAfter();
            showDonationAfterFrenchTax();
            showDonationAfterFrenchTaxFree();
        });

        $('#organisation:not(.disabled)').click(function () {
            organisation();
            $(this).addClass('active');
            $('.error-message').text('');
            reorderTabIndexAfterChange();
        });
        $('#individual:not(.disabled)').click(function () {
            individual();
            $(this).addClass('active');
            $('.error-message').text('');
            reorderTabIndexAfterChange();
        });

        $('#corporate:not(.disabled)').click(function () {
            corporate();
            $(this).addClass('active');
            $('.error-message').text('');
            reorderTabIndexAfterChange();
        });

        $('#make_donation:not(.disabled)').click(function () {
            makeDonation();
            $(this).addClass('active');
            $('.error-message').text('');
            reorderTabIndexAfterChange();
        });

        switch ($('#type_subscription').val()) {
            case 'organisational':
                organisation();
                $('#organisation').addClass('active');
                break;
            case 'individual':
                individual();
                $('#individual').addClass('active');
                break;
            case 'corporate':
                corporate();
                $('#corporate').addClass('active');
                break;
            case 'free-donation':
                makeDonation();
                $('#make_donation').addClass('active');
                break;
            default:
                break;
        }

        // Phones
        window.tels = [];
        if ($('[data-behavior~=phone-number]').length > 0) {
            $.fn.intlTelInput.loadUtils('https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/13.0.2/js/utils.js');
            $('[data-behavior~=phone-number]').each(function () {
                let $frontField = $(this).find('input[type=text]');
                let $hiddenField = $(this).find('input[type=hidden]');
                let initialCountry = 'FR';

                $frontField.intlTelInput({
                    initialCountry: initialCountry,
                    hiddenInput: $hiddenField.attr('name'),
                    customPlaceholder: function (selectedCountryPlaceholder) {
                        return 'Example: ' + selectedCountryPlaceholder;
                    }
                });

                $frontField.intlTelInput('setNumber', $hiddenField.val());
                if ($frontField.val().length !== 0) {
                    let countryData = $frontField.intlTelInput('getSelectedCountryData');

                    $frontField.intlTelInput('setCountry', countryData.iso2);
                }
                window.tels.push($frontField);
                $(this).attr('state', 'rendered');
            });
        }

        // Show section only if radio/checkbox selected
        if ($('[data-behavior~=show-if-true]').length > 0) {
            let base = this;

            $('[data-behavior~=show-if-true]').each(function () {
                let $target = $(this);

                base.hideOrShow($($target).data('truevalue'), $(this), $target);
                $('[name=' + $(this).siblings('input[type=radio]')
                    .attr('name') + ']')
                    .change(function () {
                        base.hideOrShow($($target).data('truevalue'), $(this), $target);
                    });
            });
        }

        if ($('.free-col-wrapper').length > 0) {
            let base = this;

            $('[data-behavior~=show-if-true]').each(function () {
                let $target = $(this);

                base.hideOrShow($($target).data('truevalue'), $(this), $target);
                $('[name=' + $(this).siblings('input[type=radio]')
                    .attr('name') + ']')
                    .change(function () {
                        base.hideOrShow($($target).data('truevalue'), $(this), $target);
                    });
            });
        }

        if ($('#imgLogo').length > 0) {
            let base = this;

            $('#imgLogo').change(function () {
                base.readUrl(this, 'preview');
            });
        }

        let today = new Date();
        let date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();

        $('#birth').datetimepicker({
            timepicker: false,
            format: 'd/m/Y',
            defaultDate: (new Date()).setFullYear((new Date()).getFullYear() - 18),
            maxDate: date,
            yearEnd: today.getFullYear()
        });

        $('.project-datepicker').datetimepicker({
            timepicker: false,
            format: 'd/m/Y'
        });

        /**
         * Jump to error messages
         */
        if ($('.error-message:not(:empty)').length > 0) {
            let $firstErrorMessage = $('.error-message:not(:empty)').first()
                .parent();

            // console.log($firstErrorMessage);
            let interval = setInterval(function () {
                $('html, body').stop()
                    .animate({ 'scrollTop': $firstErrorMessage.offset().top - $('.main-menu').outerHeight() }, 600, 'swing');
                clearInterval(interval);
            }, 500);
        }
        function showDonationAfterFrenchTax () {
            console.log(' showDonationAfterFrenchTax()', $('[name="category"]:checked').attr('data-donation'), $('#category').data('reduction'));

            let donation = $('[name="category"]:checked').attr('data-donation');
            let isPaysFrance = 0;

            if ($('#type_subscription').val() === 'corporate' && $('[name=country_code_billing]').val()) {
                isPaysFrance = $('[name=country_code_billing]').val();
            } else {
                isPaysFrance = $('[name=country_code]').val();
            }

            console.log(
                'ville', $('[name=country_code]').val(),
                'ville billing', $('[name=country_code_billing]').val(),
                'isPays', isPaysFrance,
                'donation', donation);

            if (isPaysFrance === '75' && donation > 0) { // France
                let frenchTaxReduction = $('#category').data('reduction');

                if ($('#type_subscription').val() === 'corporate') {
                    frenchTaxReduction = $('#category').data('reductioncorporate');
                }
                console.log('tax reduxtion: %', frenchTaxReduction, $('#category').data('reductioncorporate'), $('#type_subscription').val());

                let taxReduction = donation - Math.ceil(donation * (frenchTaxReduction / 100));

                // $('#french-tax-reduction').text(numberFormat(taxReduction, 0, false, ','));
                taxReduction = taxReduction.toLocaleString(undefined, 'en-US', { minimumFractionDigits: 2 });

                /* $('[name="category"]:checked').next()
                    .next()
                    .children('b')
                    .text(taxReduction); */

                $('.toggle-donation-label').children('b')
                    .text(taxReduction);

                $('.toggle-donation-label').show();
            } else {
                /* $('[name="category"]').next()
                    .next()
                    .hide(); */

                $('.toggle-donation-label').hide();

                return false;
            }

            /* $('[name="category"]').next()
                .next()
                .hide();
            $('[name="category"]:checked').next()
                .next()
                .show(); */
        }

        $('[name="category"]').on('change', function () {
            showDonationAfterFrenchTax();
        });

        function showDonationAfterFrenchTaxFree () {
            console.log($('[name="free_donation"]').val());

            let donation = 0;

            if (!donation) {
                let definedDonation50 = $('#free_donation_defined_50').is(':checked');
                let definedDonation80 = $('#free_donation_defined_80').is(':checked');
                let definedDonation100 = $('#free_donation_defined_100').is(':checked');
                let definedDonation200 = $('#free_donation_defined_200').is(':checked');
                let definedDonation500 = $('#free_donation_defined_500').is(':checked');
                let definedDonation750 = $('#free_donation_defined_750').is(':checked');
                let definedDonation1500 = $('#free_donation_defined_1500').is(':checked');
                let definedDonation5000 = $('#free_donation_defined_5000').is(':checked');

                if (definedDonation50) {
                    donation = 50;
                } else if (definedDonation80) {
                    donation = 80;
                } else if (definedDonation100) {
                    donation = 100;
                } else if (definedDonation200) {
                    donation = 200;
                } else if (definedDonation500) {
                    donation = 500;
                } else if (definedDonation750) {
                    donation = 750;
                } else if (definedDonation1500) {
                    donation = 1500;
                } else if (definedDonation5000) {
                    donation = 5000;
                } else {
                    donation = parseInt($('[name="free_donation"]').val());
                }
            }

            let isPaysFrance = 0;

            donationValueHandler();

            if ($('.free-donation-template').length > 0) {
                if (donation > 5) {
                    $('#benefiting .form-wrapper').show();
                } else {
                    $('#benefiting .form-wrapper').hide();
                }
            }

            if ($('#type_subscription').val() === 'corporate') {
                isPaysFrance = $('[name=country_code_billing]').val();
            } else {
                isPaysFrance = $('[name=country_code]').val();
            }

            if (isPaysFrance === '75' && donation && donation > 4) { // France
                let frenchTaxReduction = $('#category').data('reduction');

                if ($('#type_subscription').val() === 'corporate') {
                    frenchTaxReduction = $('#category').data('reductioncorporate');
                }
                console.log('tax reduxtion: %', frenchTaxReduction);

                let taxReduction = donation - Math.ceil(donation * (frenchTaxReduction / 100));

                taxReduction = taxReduction.toLocaleString(undefined, 'en-US', { minimumFractionDigits: 2 });
                $('#free_donation_label')
                    .children('b')
                    .text(taxReduction);
                $('#free_donation_label')
                    .show();
            } else {
                $('#free_donation_label')
                    .hide();

                return false;
            }
        }

        $('[name="free_donation"]').bind('keyup mouseup', function () {
            showDonationAfterFrenchTaxFree();
        });

        $('[name="free_donation_defined"]').on('click', function () {
            showDonationAfterFrenchTaxFree();
        });

        if ($('.paymentBtn').length > 0) {
            $('.paymentBtn').on('click', function () {
                let isActive = false;

                if (!$(this).hasClass('active') && $(this).attr('for') === 'payement_methode-1') {
                    $('#check-detail').removeClass('active');
                    $('#bank-transfert').removeClass('active');
                    $('#stripe-service').addClass('active');
                    // $('.credit-card-description').addClass('active');
                    $('.paymentBtn').removeClass('active');
                    $(this).addClass('active');

                    // render stripe
                    if ($('#card-element-donation').children().length === 0) {
                        renderStripe();
                    }

                    isActive = true;
                } else if (!$(this).hasClass('active') && $(this).attr('for') === 'payement_methode-2') {
                    $('#stripe-service').removeClass('active');
                    $('#check-detail').removeClass('active');
                    $('#bank-transfert').addClass('active');
                    // $('.credit-card-description').removeClass('active');
                    $('.paymentBtn').removeClass('active');
                    $(this).addClass('active');

                    if ($('#card-element-donation').children().length !== 0) {
                        $('#card-element-donation').empty();
                    }

                    isActive = true;
                } else if (!$(this).hasClass('active') && $(this).attr('for') === 'payement_methode-3') {
                    $('#check-detail').addClass('active');
                    $('#stripe-service').removeClass('active');
                    $('#bank-transfert').removeClass('active');
                    // $('.credit-card-description').removeClass('active');
                    $('.paymentBtn').removeClass('active');

                    $(this).addClass('active');
                    if ($('#card-element-donation').children().length !== 0) {
                        $('#card-element-donation').empty();
                    }

                    isActive = true;
                } else {
                    $('#stripe-service').removeClass('active');
                    $('#bank-transfert').removeClass('active');
                    $('#check-detail').removeClass('active');
                    // $('.credit-card-description').removeClass('active');
                    $('.paymentBtn').removeClass('active');

                    if ($('#card-element-donation').children().length !== 0) {
                        $('#card-element-donation').empty();
                    }

                    isActive = false;
                }

                if (isActive) {
                    $('#submit-section button').removeClass('disabled');
                } else {
                    $('#submit-section button').addClass('disabled');
                }
            });
        }

        function reorderTabIndexAfterChange () {
            let tabindex = 1;

            $('input,select').each(function () {
                if (this.type !== 'hidden') {
                    let $input = $(this);

                    // console.log('input', $input, tabindex);
                    $input.attr('tabindex', tabindex);
                    tabindex++;
                }
            });
        }

        function filterRoadshow () {
            $('#filter-roadshow').on('change', function () {
                window.location.href = '/platform/about-the-platform-project' + (this.value ? '/' + this.value : '');
            });
        }

        function filterCompetition () {
            $('#filter-competition').on('change', function () {
                window.location.href = window.location.pathname + (!isNaN(this.value) ? ('?competition=' + this.value) : '');
            });
        }

        function filterPrize () {
            $('#filter-prize').on('change', function () {
                window.location.href = window.location.pathname + '?competition=' + $(this).data('competition') + (this.value ? '&prize=' + this.value : '') + ($(this).data('country') ? '&country=' + $(this).data('country') : '');
            });
        }

        function filterCountry () {
            $('#filter-country').on('change', function () {
                let path = window.location.pathname;

                if ($(this).data('competition')) {
                    path += '?competition=' + $(this).data('competition');

                    if ($(this).data('prize')) {
                        path += '&prize=' + $(this).data('prize');
                    }

                    if (this.value) {
                        path += '&country=' + this.value;
                    }
                } else {
                    path += '?country=' + this.value;
                }

                window.location.href = path;
            });
        }

        function renderStripe () {
            // Stripe
            if ($('#card-element').length) {
                $('.wait-stripe').prop('disabled', 'disabled');
                $('.wait-stripe').addClass('disabled', 'disabled');
                let checkExist = setInterval(function () {
                    if (window.Stripe) {
                        clearInterval(checkExist);

                        let stripe = window.Stripe($('#card-element').data('stripe'), { locale: 'en' });

                        window.stripe = stripe;

                        let elements = window.stripe.elements({});
                        // Custom Styling
                        let style = {
                            base: {
                                color: '#000',
                                lineHeight: '24px',
                                fontFamily: '"Barlow", arial, sans-serif',
                                fontSmoothing: 'antialiased',
                                fontSize: '16px',
                                '::placeholder': { color: '#767676' }
                            },
                            invalid: {
                                color: '#fa755a',
                                iconColor: '#fa755a'
                            }
                        };

                        // Create an instance of the card Element
                        window.card = elements.create('card', { style: style });

                        window.card.mount('#card-element');
                        window.card.addEventListener('change', function (event) {
                            let displayError = document.getElementById('card-errors');

                            if (event.error) {
                                displayError.textContent = event.error.message;
                            } else {
                                displayError.textContent = '';
                            }
                        });

                        $('.wait-stripe').prop('disabled', '');
                        $('.wait-stripe').removeClass('disabled');
                    }
                }, 100);
            } else if ($('#card-element-donation').length) {
                let checkExist = setInterval(function () {
                    if (window.Stripe) {
                        clearInterval(checkExist);

                        let stripe = window.Stripe($('#card-element-donation').data('stripe'), { locale: 'en' });

                        window.stripe = stripe;

                        let elements = window.stripe.elements({});
                        // Custom Styling
                        let style = {
                            base: {
                                color: '#000',
                                lineHeight: '24px',
                                fontFamily: '"Barlow", arial, sans-serif',
                                fontSmoothing: 'antialiased',
                                fontSize: '16px',
                                '::placeholder': { color: '#767676' }
                            },
                            invalid: {
                                color: '#fa755a',
                                iconColor: '#fa755a'
                            }
                        };

                        // Create an instance of the card Element
                        window.card = elements.create('card', { style: style });

                        window.card.mount('#card-element-donation');
                        window.card.addEventListener('change', function (event) {
                            let displayError = document.getElementById('card-errors');

                            if (event.error) {
                                displayError.textContent = event.error.message;
                            } else {
                                displayError.textContent = '';
                            }
                        });
                    }
                }, 100);
            }
        }

        function renderMembershipRecaptcha () {
            if ($('#grecaptcha-membership').length) {
                window.currentForm = 'membership-form';

                if (!window.isInitializedRecaptchaMembership) {
                    window.grecaptcha.ready(function () {
                        window.grecaptcha.render('grecaptcha-membership', {
                            'sitekey': $('#grecaptcha-membership').data('sitekey'),
                            'callback': function (token) {
                                // return new Promise(function (resolve, reject) {
                                return new Promise(function () {
                                    base.recaptchaCallback(token, $('.btn-membership-confirm'), base.jxComplete);
                                });
                            },
                            'size': 'invisible'
                        });

                        window.isInitializedRecaptchaMembership = true;
                    });
                }

                $('.btn-membership-confirm').click(function (event) {
                    event.preventDefault();
                    $(this).prop('disabled', 'disabled');
                    $(this).addClass('right-spin');
                    $(this).addClass('disabled');
                    window.grecaptcha.execute();
                });
            }
        }

        function scrollToTopIfSuccessMessage () {
            if ($('.message-membership:not(:empty)').length) {
                $('html, body').stop()
                    .animate({ 'scrollTop': $('.message-membership:not(:empty)').offset().top - $('.main-menu').outerHeight() }, 600, 'swing');
            }
        }

        $(document).ready(function () {
            showDonationAfterFrenchTaxFree();
            showDonationAfterFrenchTax();
            reorderTabIndexAfterChange();
            filterRoadshow();
            filterCompetition();
            filterPrize();
            filterCountry();
            $('#free_donation_txt').text($('#free_donation').val() * 2);
            checkTgeIndividualMembershipCategory(true);
            handleBillingAddress($('input#different_billing_address'));
            renderStripe();
            renderMembershipRecaptcha();
            scrollToTopIfSuccessMessage();

            self.is_equalHeight = true;

            self.equalHeight('titleContentEqualHeight');
            self.equalHeight('subtitleEqualHeight');
            self.equalHeight('descBiennalHeight');
            self.equalHeight('catBiennalHeight');
            self.equalHeight('impactsBiennalHeight');
        });

        $(document).ready(function () {
            $('.tabs-container input[name="tabs"]').each(function () {
                let tabActive = $(this);

                $('.tabs-container .tabs label:first-child').addClass('active-label');
                tabActive.click(function () {
                    let currentSection = $(this).data('section');
                    let sectionContent = $(this).closest('.tabs-container')
                        .find('.content');
                    let sectionContentTab = sectionContent.find('#section-' + currentSection);
                    let sectionLabel = $(this).closest('.tabs-container')
                        .find('.tabs');
                    let sectionContentLabel = sectionLabel.find('label');
                    let sectionContentLabelByFor = sectionLabel.find('label[for="' + currentSection + '"]');

                    sectionContentLabel.removeClass('active-label');
                    sectionContentLabelByFor.addClass('active-label');

                    sectionContent.find('.tab').removeClass('active');
                    sectionContentTab.addClass('active');
                });
            });

            // Add 'show' class to the first section--jury
            $('.section--jury:first').addClass('show');
            $('.nexstage-jury:first').addClass('show');

            $('#jury-select').change(function () {
                const selectedYear = $(this).val();

                $('.section--jury:not(.nexstage-jury)').removeClass('show'); // Hide all section--jury
                $('.nexstage-jury').removeClass('show');
                if (selectedYear === 'all') {
                    $('.section--jury:not(.nexstage-jury)').addClass('show'); // Show all section--jury if "All Years" selected
                    $('.nexstage-jury').addClass('show');
                } else {
                    $(`.section--jury[data-year="${selectedYear}"]:not(.nexstage-jury)`).addClass('show'); // Show section--jury for the selected year
                    $(`.nexstage-jury[data-year="${selectedYear}"]`).addClass('show');
                }

                // Scroll to the specified ID div
                const targetDiv = $(`#tab-${selectedYear}`);

                if (targetDiv.length > 0) {
                    $('html, body').animate({  scrollTop: targetDiv.offset().top }, 800);
                } else {
                    console.error(`Target div with ID "tab-${selectedYear}" not found.`);
                }
            });
        });
    },

    equalHeight (className) {
        let resize = this.is_equalHeight;
        let elements = document.getElementsByClassName(className);
        let allHeights = [];
        let i = 0;

        if (elements.length > 0) {
            if (resize === true) {
                for (i = 0; i < elements.length; i++) {
                    elements[i].style.height = 'auto';
                }
            }

            for (i = 0; i < elements.length; i++) {
                let elementHeight = elements[i].clientHeight;

                allHeights.push(elementHeight);
            }

            for (i = 0; i < elements.length; i++) {
                elements[i].style.height = Math.max.apply(Math, allHeights) + 'px';

                if (resize === false) {
                    elements[i].className = elements[i].className + ' show';
                }
            }
        }
    },

    readUrl (input, idPreview) {
        if (input.files && input.files[0]) {
            let reader = new FileReader();

            reader.onload = function (e) {
                $('#' + idPreview).html('<img src="' + e.target.result + '" alt="preview" >');
            };

            reader.readAsDataURL(input.files[0]);
        }
    },

    initializeMembers () {
        const base = this;
        let jxRetrieveGrid;
        let jxRetrieveList;
        let jxRetrieveMap;
        let routeList = JSON.parse($('#fedora').attr('data-routes'));
        let constantsList = JSON.parse($('#fedora').attr('data-consts'));

        // Grid and list Swapper
        $('.btn-wrapper--load-more').click(function () {
            const loadMoreBtn = $(this);

            if (!loadMoreBtn.hasClass('disabled')) {
                loadMoreBtn.addClass('disabled');
                if ($('#members-grid').is(':visible')) {
                    // Grid

                    if (jxRetrieveGrid) {
                        jxRetrieveGrid.abort();
                    }
                    jxRetrieveGrid = $.ajax({
                        method: 'get',
                        url: routeList.ajax_platform_members,
                        data: { count: $('#members-grid .list--grid--item').length }
                    }).done(function (data) {
                        $('#members-grid .row').append($(data.join('')));
                    })
                        .fail(function () {
                            base.log('Error retrieving member list');
                        })
                        .always(function () {
                            setLoadMoreBtn();
                            loadMoreBtn.removeClass('disabled');
                        });
                } else {
                    // List

                    if (jxRetrieveList) {
                        jxRetrieveList.abort();
                    }
                    jxRetrieveList = $.ajax({
                        method: 'get',
                        url: routeList.ajax_all_members,
                        data: { count: $('#members-list .list--grid--item').length }
                    }).done(function (data) {
                        $('#members-list .row').append($(data.join('')));
                    })
                        .fail(function () {
                            base.log('Error retrieving member list');
                        })
                        .always(function () {
                            setLoadMoreBtn();
                            loadMoreBtn.removeClass('disabled');
                        });
                }
            }
        });

        function getTabActive () {
            let currentHash = window.location.hash;

            if (currentHash === '#platform-members') {
                return 'platform-members';
            } else if (currentHash === '#all') {
                return 'all';
            } else {
                return 'platform-members';
            }
        }

        // Load More Button
        function setLoadMoreBtn (tabActive) {
            const loadMoreBtn = $('.btn-wrapper--load-more');

            if (tabActive === undefined) {
                tabActive = getTabActive();
            }

            loadMoreBtn.show();
            if (tabActive === 'platform-members' && $('#members-grid .list--grid--item').length >= loadMoreBtn.attr('data-how-many-platform-members')) {
                loadMoreBtn.hide();
            }
            if (tabActive === 'all' && $('#members-list .list--grid--item').length >= loadMoreBtn.attr('data-how-many-all')) {
                loadMoreBtn.hide();
            }
        }

        // Anchor watcher
        function setTabActive (tabActive) {
            if (tabActive === undefined) {
                tabActive = getTabActive();
            }

            if (tabActive === 'platform-members') {
                $('#members-grid').show();
                $('#members-list').hide();
                $('.menu-members-grid').show();
                $('.menu-members-list').hide();
            } else {
                $('#members-grid').hide();
                $('#members-list').show();
                $('.menu-members-grid').hide();
                $('.menu-members-list').show();
            }

            // Lateral Menu
            $('.lateral-menu').each(function () {
                $(this).removeClass('active');
                if ($(this).attr('href')
                    .substr(1) === tabActive) {
                    $(this).addClass('active');
                }
            });

            setLoadMoreBtn(tabActive);
        }

        $('.lateral-menu').unbind('click')
            .click(function () {
                setTabActive($(this).attr('href')
                    .substr(1));
            });

        $('.members--list-menu-top').unbind('click')
            .click(function () {
                let $where = $($(this).attr('href'));

                console.log('test scroll', $where.offset().top - $('.main-new-menu').outerHeight());
                $('html, body').stop()
                    .animate({ 'scrollTop': $where.offset().top - $('.main-new-menu').outerHeight() }, 600, 'swing');
            });

        // Google Map
        let map = new GMaps({
            el: '#members-map',
            disableDefaultUI: true,
            lat: constantsList.google_map_lat,
            lng: constantsList.google_map_long,
            zoom: constantsList.google_map_zoom,
            styles: gMapStyle
        });

        function setMap () {
            let dataGet = [];
            let i = 0;

            $('.map-btn').each(function () {
                if ($(this).hasClass('active')) {
                    console.log($(this).attr('data-member-type'));
                    dataGet.push($(this).attr('data-member-type'));
                }
            });

            map.removeMarkers();
            if (jxRetrieveMap) {
                jxRetrieveMap.abort();
            }
            jxRetrieveMap = $.ajax({
                method: 'get',
                url: routeList.ajax_all_members_for_map,
                data: { types: dataGet }
            }).done(function (data) {
                for (i = 0; i < data.length; i++) {
                    let member = data[i];
                    let image;

                    if (member.type === 'platform-member') {
                        image = '/images/icon-platform-member.png';
                    } else {
                        image = '/images/icon-member.png';
                    }
                    map.addMarker({
                        lat: member.latitude,
                        lng: member.longitude,
                        title: member.name,
                        icon: image,
                        infoWindow: { content: member.tooltip }
                    });
                }
            })
                .fail(function () {
                    base.log('Error retrieving member list for map');
                });
        }

        $('.map-btn').unbind('click')
            .click(function (e) {
                e.preventDefault();

                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');

                    // Prevent no selection
                    if ($('.map-btn.active').length === 0) {
                        $(this).addClass('active');

                        return false;
                    }
                } else {
                    $(this).addClass('active');
                }
                setMap();
            });

        setMap();
        setTabActive();
    },

    userHandlers () {
        let loginRoute = $('#popup--login').attr('data-route-login');
        let forgotRoute = $('#popup--login').attr('data-route-forgot');
        let authenticateOrFail;
        let forgotOrFail;
        let base = this;
        let userMail;
        let userPassword;
        let userRemember = false;
        let forgottenEmail;
        let forgottenBtn = $('#forgot-password').find('[type="submit"]');

        $('#forgot-password').submit(function (event) {
            event.preventDefault();

            if (forgotOrFail) {
                return false;
            }

            forgottenEmail = $('#forgot-password').serializeArray()[0].value;
            if (!base.validateEmail(forgottenEmail)) {
                $('.form-wrapper.forgot_email > .error-message').text('invalid email format');

                return false;
            }

            forgottenBtn.addClass('right-spin');

            forgotOrFail = $.ajax({
                url: forgotRoute,
                type: 'post',
                dataType: 'json',
                data: { email: forgottenEmail }
            }).done(function (data) {
                forgottenBtn.removeClass('right-spin');

                if (data.errors.length > 0) {
                    console.log('errors : ', data.errors);

                    $.each(data.errors, function (index, value) {
                        $('.form-wrapper.' + value.key + ' > .error-message').text(value.message);
                    });
                } else {
                    if (data.success) {
                        console.log('success', data.success);
                        $('body').removeClass(base.formatedPopupClasses());
                        $('body').addClass('popup-open popup-forgot-open');
                    }
                }
            })
                .fail(function () {
                    base.log('Error connecting to auth');
                })
                .always(function () {
                    base.log('jquery executed');
                    forgotOrFail = false;
                });

            return false;
        });

        $('.btn-login').click(function (event) {
            event.preventDefault();

            let currentRoute = $('#popup--login').attr('data-current-route');
            let loginBtn = $(this);

            if (authenticateOrFail) {
                return false;
            }

            $('.form-wrapper.email > .error-message').text('');
            $('.form-wrapper.password > .error-message').text('');

            if ($('.form-wrapper.email > #remember').is(':checked')) {
                userRemember = true;
            }

            userMail = $('.form-wrapper.email > [name="email"]').val();
            userPassword = $('.form-wrapper.password > [name="password"]').val();

            if (userMail !== '' && base.validateEmail(userMail)) {
                loginBtn.addClass('right-spin');

                authenticateOrFail = $.ajax({
                    method: 'post',
                    url: loginRoute,
                    data: {
                        email: userMail,
                        password: userPassword,
                        remember: userRemember,
                        currentRoute: currentRoute
                    },
                    dataType: 'json'
                }).done(function (data) {
                    loginBtn.removeClass('right-spin');

                    if (data.errors.length > 0) {
                        console.log('errors : ', data.errors);

                        $.each(data.errors, function (index, value) {
                            $('.form-wrapper.' + value.key + ' > .error-message').text(value.message);
                        });
                    } else {
                        if (data.success) {
                            $('.popup--close').click();
                            console.log('success', data.success);
                            window.location.href = data.success.route;
                        }
                    }
                })
                    .fail(function () {
                        base.log('Error connecting to auth');
                    })
                    .always(function () {
                        base.log('jquery executed');
                        authenticateOrFail = false;
                    });
            } else if (userMail !== '') {
                $('.form-wrapper.email > .error-message').text('invalid email format');
            }

            return false;
        });

        if ($('#popup--login .message').length > 0) {
            $('.link-show-login').trigger('click');
        }
    },

    onValidForm (event) {
        let registerOrFail;
        let base = this;
        let userFirstName;
        let userLastName;
        let userMail;
        let userPassword;
        let userPasswordConfirmation;
        let userCountry;
        let userAcceptTerms = false;
        let userWantNewsLetter = false;
        let isValidForm = false;

        event.preventDefault();
        // const registerBtn = $('.btn-register');

        if (registerOrFail) {
            return false;
        }

        // $('.form-wrapper > .error-message').text('');
        $('.error-message').text('');

        if ($('.form-checkbox > [name="user_terms"]').is(':checked')) {
            userAcceptTerms = true;
        }

        if ($('.form-checkbox > [name="user_newsletter"]').is(':checked')) {
            userWantNewsLetter = true;
        }

        // Show error by order
        userFirstName = $('.form-wrapper.first_name > [name="first_name"]').val();
        if (!userFirstName) {
            $('.form-wrapper.first_name > .error-message').text('First name is mandatory');
        } else {
            userLastName = $('.form-wrapper.last_name > [name="last_name"]').val();
            if (!userLastName) {
                $('.form-wrapper.last_name > .error-message').text('Last name is mandatory');
            } else {
                userMail = $('.form-wrapper.signup_email > [name="email"]').val();
                if (!userMail) {
                    $('.form-wrapper.signup_email > .error-message').text('Email is mandatory');
                } else if (!base.validateEmail(userMail)) {
                    $('.form-wrapper.signup_email > .error-message').text('Invalid format');
                } else {
                    userCountry = $('.form-wrapper.signup_country > div > [name="country"]').val();
                    if (!userCountry) {
                        $('.form-wrapper.signup_country > .error-message').text('Please select a country');
                    } else {
                        // Password verification
                        userPassword = $('.form-wrapper.signup_password > [name="password"]').val();
                        if (!userPassword) {
                            $('.form-wrapper.signup_password > .error-message').text('Empty password');
                        } else if (userPassword.length < 8) {
                            $('.form-wrapper.signup_password > .error-message').text('Must be 8 characters min');
                        } else {
                            userPasswordConfirmation = $('.form-wrapper.signup_confirmation > [name="signup_confirmation"]').val();
                            if (!userPasswordConfirmation) {
                                $('.form-wrapper.signup_confirmation > .error-message').text('Confirm your password');
                            } else if (userPasswordConfirmation !== userPassword) {
                                $('.form-wrapper.signup_password > .error-message').text('Password & confirmation did not match');
                            } else {
                                if (!userAcceptTerms) {
                                    $('.form-wrapper.user_terms > .error-message').text('You have to accept the terms & conditions');
                                } else {
                                    isValidForm = true;
                                }
                            }
                        }
                    }
                }
            }
        }

        return isValidForm;
    },

    submitRegister (token) {
        let registerRoute = $('#popup--signup').attr('data-route-signup');
        let userFirstName;
        let userLastName;
        let userMail;
        let userPassword;
        let userPasswordConfirmation;
        let userCountry;
        let userAcceptTerms = false;
        let userWantNewsLetter = false;
        // let userRecaptcha;
        let registerOrFail;
        const registerBtn = $('.btn-register');

        registerBtn.addClass('disabled');
        registerBtn.addClass('right-spin');
        if (registerOrFail) {
            return false;
        }
        if ($('.form-checkbox > [name="user_terms"]').is(':checked')) {
            userAcceptTerms = true;
        }

        if ($('.form-checkbox > [name="user_newsletter"]').is(':checked')) {
            userWantNewsLetter = true;
        }
        userLastName = $('.form-wrapper.last_name > [name="last_name"]').val();
        userFirstName = $('.form-wrapper.first_name > [name="first_name"]').val();
        userMail = $('.form-wrapper.signup_email > [name="email"]').val();
        userPassword = $('.form-wrapper.signup_password > [name="password"]').val();
        userPasswordConfirmation = $('.form-wrapper.signup_confirmation > [name="signup_confirmation"]').val();
        userCountry = $('.form-wrapper.signup_country > div > [name="country"]').val();

        if (window.sendingForm) {
            return;
        }
        window.sendingForm = true;
        registerOrFail = $.ajax({
            method: 'post',
            url: registerRoute,
            data: {
                email: userMail,
                password: userPassword,
                password_confirmation: userPasswordConfirmation,
                country: userCountry,
                first_name: userFirstName,
                last_name: userLastName,
                is_newsletter: userWantNewsLetter,
                'g-recaptcha-response': token
            },
            dataType: 'json'
        })
            .done(function (data) {
                registerBtn.removeClass('right-spin');
                registerBtn.removeClass('disabled');
                if (data.errors.length > 0) {
                    $.each(data.errors, function (index, value) {
                        $('.form-wrapper.' + value.key + ' > .error-message').text(value.message);
                    });
                } else {
                    if (data.success) {
                        $('body').removeClass(window.formatedPopupClasses);
                        $('body').addClass('popup-open popup-verify-email-open');

                        $('#popupForm')[0].reset();
                    }
                }
            })
            .fail(function () {
                registerBtn.removeClass('right-spin');
                registerBtn.removeClass('disabled');
                console.log('Error connecting to auth');
            })
            .always(function () {
                console.log('jquery executed');
                registerOrFail = false;
                window.grecaptcha.reset();
                window.sendingForm = false;
            });
    },

    showNewsletterPopup () {
        console.log('Rendering recaptcha ...');

        let base = this;

        window.currentForm = 'newsletter';

        if (typeof window.grecaptcha !== 'undefined') {
            if (!window.isInitializedRecaptchaNewsletter) {
                window.grecaptcha
                    .ready(
                        () => {
                            console.log('Recaptcha rendered');

                            window.grecaptcha
                                .render(
                                    'grecaptcha-newsletter',
                                    {
                                        'sitekey': $('#grecaptcha-newsletter').data('sitekey'),
                                        'callback': function (token) {
                                            // return new Promise(function (resolve, reject) {
                                            return new Promise(function () {
                                                base.recaptchaCallback(token, false, false);
                                            });
                                        },
                                        'size': 'invisible'
                                    }
                                );
                            window.isInitializedRecaptchaNewsletter = true;
                        }
                    );
            } else {
                window.grecaptcha.reset();
            }

            $('body').addClass('popup-open popup-newsletter-registration-open');

            // Close menu
            // $('body').toggleClass('menu-opened');
            $('body').removeClass('menu--user--open');
            $('body').removeClass('bc-submenu-open');
            $('body').removeClass('submenu-active');
            $('.main-menu--item').removeClass('submenu--open');
            $('.submenu').removeClass('open');
        } else {
            // $('body').toggleClass('menu-opened');
            $('body').removeClass('menu--user--open');
            $('body').removeClass('bc-submenu-open');
            $('body').removeClass('submenu-active');
            $('.main-menu--item').removeClass('submenu--open');
            $('.submenu').removeClass('open');
            setTimeout(this.showNewsletterPopup, 250);
        }
    },

    recaptchaCallback (token, btnSubbmit = false, jxComplete = false) {
        console.log('window.currentForm', window.currentForm);
        if (window.currentForm === 'newsletter') {
            this.submitNewsletter(token);
        }
        if (window.currentForm === 'donation-project') {
            this.confirmCoordonnee(token, btnSubbmit, jxComplete);
        }
        if (window.currentForm === 'register') {
            this.submitRegister(token);
        }
        if (window.currentForm === 'membership-form') {
            this.validateMembership(token);
        }
    },

    validateMembership (token) {
        let base = this;
        let membershipForm = $('#membership-form');
        let hasError = false;
        let errors = [];

        membershipForm.find('.error-message').text('');

        // Check required
        membershipForm.find('.required').each(
            function () {
                const field = $(this).find('input, select, textarea');
                const fieldLabel = $(this).find('label');

                if (!field.val()) {
                    $(this).find('.error-message').text(fieldLabel.text().replace(' *', '') + ' is mandatory');
                    hasError = true;
                    errors.push(fieldLabel.text().replace(' *', '') + ' is mandatory', $(this).find('#error-message-url-mandatory'));

                    $(this).find('#error-message-url-mandatory').removeClass('hidden-content');
                } else {
                    $(this).find('#error-message-url-mandatory').addClass('hidden-content');
                }
            });

        if ($('input[name="different_billing_address"]').is(':checked')) {
            membershipForm.find('.if-different_billing_address-required').each(
                function () {
                    const field = $(this).find('input, select, textarea');
                    const fieldLabel = $(this).find('label');

                    if (!field.val()) {
                        $(this).find('.error-message')
                            .text(fieldLabel.text().replace(' *', '') + ' is mandatory');
                        hasError = true;

                        errors.push(fieldLabel.text().replace(' *', '') + ' is mandatory');
                    }
                }
            );
        }

        let categorie = false;
        let benefiting = false;
        let payement = false;
        let truthful = false;
        let phoneNumberTemp = false;
        // let phoneNumber = false;
        let generalPhoneNumberTemp = false;
        let phoneNumberPersonTemp = false;
        // let phoneNumberPerson = false;
        let logo = false;

        // Individual
        membershipForm.find('input[name="category"]').each(function () {
            if ($(this).is(':checked')) {
                categorie = true;
            }
        });

        if (!categorie && $('input[name="category"]').length) {
            hasError = true;
            $('.error-message.category').text('Membership category is mandatory');
            errors.push('Membership category is mandatory');
        }

        membershipForm.find('input[name="benefiting"]').each(function () {
            if ($(this).is(':checked')) {
                benefiting = true;
            }
        });

        if (!benefiting && $('input[name="benefiting"]').length && !$('input[name="tge_individual"]').length) {
            hasError = true;
            $('.error-message.benefiting').text('Donation beneficiary is mandatory');
            errors.push('Donation beneficiary is mandatory');
        }

        membershipForm.find('input[name="payement"]').each(function () {
            if ($(this).is(':checked')) {
                payement = true;
            }
        });

        if (!payement && $('input[name="payement"]').length) {
            hasError = true;
            $('.error-message.payement').text('Payment method is mandatory');
            errors.push('Payment method is mandatory');
        }

        membershipForm.find('input[name="truthful"]').each(function () {
            if ($(this).is(':checked')) {
                truthful = true;
            }
        });

        if (!truthful && $('input[name="truthful"]').length) {
            hasError = true;
            $('.error-message.truthful').text('This field is mandatory');
            errors.push('This field is mandatory');
        }

        membershipForm.find('input[name="phone_number_temp"]').each(function () {
            if ($(this).val()) {
                phoneNumberTemp = true;
            }
        });

        if (!phoneNumberTemp && $('input[name="phone_number_temp"]').length && !$('#free-donation-position').length) {
            hasError = true;
            $('.error-message.phone_number_temp').text('Phone number is mandatory');
            errors.push('Phone number is mandatory');
        }

        membershipForm.find('input[name="general_phone_number_temp"]').each(function () {
            if ($(this).val()) {
                generalPhoneNumberTemp = true;
            }
        });

        if (!generalPhoneNumberTemp && $('input[name="general_phone_number_temp"]').length) {
            hasError = true;
            $('.error-message.general_phone_number_temp').text('General phone number is mandatory');
            errors.push('General phone number is mandatory');
        }

        membershipForm.find('input[name="phone_number_person_temp"]').each(function () {
            if ($(this).val()) {
                phoneNumberPersonTemp = true;
            }
        });

        if (!phoneNumberPersonTemp && $('input[name="phone_number_person_temp"]').length) {
            hasError = true;
            $('.error-message.phone_number_person_temp').text('Phone number is mandatory');
            errors.push('Phone number is mandatory');
        }

        // Free donation
        let freeDonation = false;
        let freeDonationDefined = false;

        membershipForm.find('input[name="free_donation_defined"]').each(function () {
            if ($(this).is(':checked')) {
                freeDonationDefined = true;
            }
        });

        if (!freeDonationDefined && $('input[name="free_donation"]').length) {
            membershipForm.find('input[name="free_donation"]').each(function () {
                if ($(this).val() && parseFloat($(this).val()) > 0) {
                    freeDonation = true;
                }
            });
        }

        if ($('input[name="free_donation_defined"]').length) { // free donation
            if (parseFloat($('input[name="free_donation"]').val()) <= 0) {
                hasError = true;
                $('.error-message.free_donation').text('Donation value is invalid');
                errors.push('Donation value is invalid');
            } else if (!freeDonation && !freeDonationDefined && $('input[name="free_donation_defined"]').length) {
                hasError = true;
                $('.error-message.free_donation').text('Donation field is mandatory');
                errors.push('Donation field is mandatory');
            }
        } else { // individual membership
            if ($('input[name="free_donation"]').length) {
                if (parseFloat($('input[name="free_donation"]').val()) <= 0) {
                    hasError = true;
                    $('.error-message.free_donation').text('Donation value is invalid');
                    errors.push('Donation value is invalid');
                }
            }
        }

        membershipForm.find('input[name="logo"]').each(function () {
            if ($(this).get(0).files.length > 0) {
                logo = true;
            }
        });

        if (!logo && $('input[name="logo"]').length) {
            hasError = true;
            $('.error-message.logo').text('Logo is mandatory');
            errors.push('Logo is mandatory');
        }

        // Check Create Account
        const createAccount = $('#create_account');
        const termAgree = $('#account_term_agree');

        if (createAccount.is(':checked')) {
            membershipForm.find('.accout_data').each(
                function () {
                    const field = $(this).find('input');
                    const fieldLabel = $(this).find('label');

                    if (!field.val()) {
                        $(this).find('.error-message')
                            .text(fieldLabel.text() + ' is mandatory');
                        hasError = true;
                    }
                }
            );

            const password = $('input[name="account_password"]');
            const confirmation = $('input[name="account_password_confirmation"');

            if (password.val().length < 6) {
                hasError = true;
                password.siblings('.error-message').text('The password field must contain at least 6 characters.');
            }

            if (password.val() !== confirmation.val()) {
                hasError = true;
                confirmation.siblings('.error-message').text('Password does not match.');
            }

            if (!termAgree.is(':checked')) {
                hasError = true;
                termAgree.siblings('.error-message').text('You have to agree to the Terms & Conditions of the FEDORA Platform.');
            }
        }

        console.log('hasError = ' + hasError);
        if (!hasError) {
            for (let i = 0; i < window.tels.length; i++) {
                let frontinput = window.tels[i];
                let frontinputName = frontinput[0].name;
                let input = document.createElement('input');

                input.setAttribute('type', 'hidden');
                input.setAttribute('name', frontinputName + '_dyn');
                input.setAttribute('value', frontinput.intlTelInput('getNumber'));
                document.getElementById('membership-form').appendChild(input);
            }

            let inputRecaptcha = document.createElement('input');

            inputRecaptcha.setAttribute('type', 'hidden');
            inputRecaptcha.setAttribute('name', 'g-recaptcha-response');
            inputRecaptcha.setAttribute('value', token);
            document.getElementById('membership-form').appendChild(inputRecaptcha);

            base.submitMembership();
        } else {
            console.log('errors', errors);
            $('.btn-membership-confirm').prop('disabled', '');
            $('.btn-membership-confirm').removeClass('right-spin');
            $('.btn-membership-confirm').removeClass('disabled');
            window.grecaptcha.reset();

            base.scrollToFirstErrorMessage();
        }
    },

    scrollToFirstErrorMessage () {
        // console.log('Scrolling=', $('.error-message:not(:empty):first, .error-validation:not(:empty):first'), $('.error-message:not(:empty):first, .error-validation:not(:empty):first').parent().offset().top - $('.main-new-menu').outerHeight());
        $('html, body').stop()
            .animate({
                'scrollTop': $('.error-message:not(:empty):first, .error-validation:not(:empty):first').parent()
                    .offset().top - $('.main-new-menu').outerHeight()
            }, 600, 'swing');
    },

    submitMembership () {
        let base = this;
        let formData = new FormData(document.getElementById('membership-form'));

        // if ($('input[name="logo"]').length) {
        //     if ($('input[name="logo"]').prop('files') && $('input[name="logo"]').prop('files')[0]) {
        //         data['logo'] = $('input[name="logo"]').prop('files')[0];
        //     }
        // }
        $.ajax({
            method: 'post',
            url: '/membership-registration/store',
            data: formData,
            dataType: 'text',
            processData: false,
            contentType: false
        }).done(function (dataText) {
            let data = $.parseJSON(dataText);

            if (data.success) {
                if (data.payment_intent_client_secret !== undefined) {
                    if (data.type === 'free-donation') {
                        base.waitFreeDonationForPayment(data.payment_intent_client_secret, function () {
                            $.ajax({
                                method: 'post',
                                url: '/membership-registration/success',
                                data: formData,
                                dataType: 'text',
                                processData: false,
                                contentType: false
                            }).done(function () {
                            // }).done(function (dataText) {
                                window.location.reload();
                            });
                        }, function () {
                            $('body').removeClass(base.formatedPopupClasses());
                            $('body').addClass('popup-open popup-problem-occured-open');
                            $('.btn-membership-confirm').prop('disabled', '');
                            $('.btn-membership-confirm').removeClass('right-spin');
                            $('.btn-membership-confirm').removeClass('wait-stripe');
                            $('.btn-membership-confirm').removeClass('disabled');
                        });
                    } else {
                        base.waitForPayment(data.payment_intent_client_secret, function () {
                            $.ajax({
                                method: 'post',
                                url: '/membership-registration/success',
                                data: formData,
                                dataType: 'text',
                                processData: false,
                                contentType: false
                            }).done(function () {
                            // }).done(function (dataText) {
                                window.location.reload();
                            });
                        }, function () {
                            $('body').removeClass(base.formatedPopupClasses());
                            $('body').addClass('popup-open popup-problem-occured-open');
                            $('.btn-membership-confirm').prop('disabled', '');
                            $('.btn-membership-confirm').removeClass('right-spin');
                            $('.btn-membership-confirm').removeClass('disabled');
                        });
                    }
                } else {
                    window.location.reload();
                }

                return false;
            }

            if (data.failure_code === 'STRIPE_ERROR') {
                const formFrror = $('#card-errors');

                formFrror.text(data.message);
            } else if (!data.success) {
                if (data.errors && data.errors.length) {
                    for (let prop in data.errors) {
                        if (Object.prototype.hasOwnProperty.call(data.errors, prop)) {
                            $('#' + prop).text(data.errors.prop[0]);
                        }
                    }
                } else {
                    console.log('data', data);
                }
            } else {
                console.log('data2', data);
            }
            base.scrollToFirstErrorMessage();

            $('.btn-membership-confirm').prop('disabled', '');
            $('.btn-membership-confirm').removeClass('right-spin');
            $('.btn-membership-confirm').removeClass('disabled');
            window.grecaptcha.reset();
        })
            .fail(function (xhr) {
                $('.btn-membership-confirm').prop('disabled', '');
                $('.btn-membership-confirm').removeClass('right-spin');
                $('.btn-membership-confirm').removeClass('disabled');
                let data = $.parseJSON(xhr.responseText);

                if (data.errors !== undefined) {
                    console.log('errors : ', data.errors);
                    $.each(data.errors, function (index, value) {
                        $('#' + index + ' .error-message').html(value);
                    });
                } else {
                    base.log('Error completing user infos');
                    base.log(data);
                }

                base.scrollToFirstErrorMessage();
            });

        window.grecaptcha.reset();
    },

    submitNewsletter (token) {
        let routeList = JSON.parse($('#fedora').attr('data-routes'));
        let formNewsletterFirstame = $('form#form-newsletter-subscription input[name=first_name]').val();
        let formNewsletterLastname = $('form#form-newsletter-subscription input[name=last_name]').val();
        let formNewsletterEmail = $('form#form-newsletter-subscription input[name=email]').val();
        let data = {
            firstname: formNewsletterFirstame,
            lastname: formNewsletterLastname,
            email: formNewsletterEmail,
            token: token
        };

        $('form#form-newsletter-subscription .message.success').hide();
        $('form#form-newsletter-subscription .message.error').hide();
        $('form#form-newsletter-subscription .message.info').hide();

        $.ajax({
            method: 'post',
            url: routeList.newsletter_register,
            data: data,
            dataType: 'json'
        }).done(function (data) {
            let subscribeBtn = $('form#form-newsletter-subscription #submit-newsletter');

            subscribeBtn.removeClass('disabled');
            subscribeBtn.removeClass('right-spin');
            if (data.error) {
                $('form#form-newsletter-subscription .message.error').show();
                $('form#form-newsletter-subscription .message.error').html(data.error.message);
            } else if (data.info) {
                $('form#form-newsletter-subscription .message.info').show();
                $('form#form-newsletter-subscription .message.info').html(data.info.message);
            } else {
                if (data.success) {
                    $('form#form-newsletter-subscription .message.success').show();
                    $('form#form-newsletter-subscription .message.success').html(data.success.message);
                }
            }
        });

        window.grecaptcha.reset();
    },

    registerHandlers () {
        console.info('registerHandlers initialized');

        $('.btn-register').click(event => {
            console.log(' valide ', this.onValidForm(event));
            if (this.onValidForm(event)) {
                console.log('window.grecaptcha: ', window.grecaptcha);
                window.grecaptcha.execute();
                console.log('Now we can testing the ReCaPTCHA');
            }
        });
    },

    voteHandlers () {
        console.info('VoteHandler initialized');
        let base = this;
        let routeList = JSON.parse($('#fedora').attr('data-routes'));
        let awaitingVotes = [];

        $('.is--logged').click(function (event) {
            event.preventDefault();
            const currentProject = $(this);
            let projectId = currentProject.attr('data-project-id');
            let voteRoute = routeList.vote_proceed;
            let howManyVotes = '.how-many-votes-' + projectId;
            let howRank = '.how-rank-' + projectId;
            let currentAttribute;
            let btnClicked = $(this);

            console.log('voteRoute', voteRoute);
            console.log(howRank);
            console.log($(howRank).text());

            if (awaitingVotes.indexOf(projectId) !== -1) {
                return false;
            }

            awaitingVotes.push(projectId);
            btnClicked.addClass('right-spin');

            $.ajax({
                method: 'post',
                url: voteRoute,
                data: { projectId: projectId },
                dataType: 'json'
            }).done(function (data) {
                console.log(data);
                if (data.error) {
                    currentProject.closest('.error-message').text(data.error.message);
                } else {
                    if (data.success) {
                        currentAttribute = currentProject.attr('style');
                        console.log(currentAttribute);
                        if (typeof currentAttribute !== typeof undefined && currentAttribute !== false) {
                            currentProject.removeAttr('style').text(data.success.message);
                        } else {
                            console.log('how many vote style : ', $(howRank).attr('style'));
                            currentProject.attr('style', $(howRank).attr('style'));
                            currentProject.find('.vote-text').text(data.success.message_less);
                        }
                        $('#total_how_many_votes').text(data.success.total_how_many_votes);
                        $(howManyVotes).text(data.success.how_many_votes);
                        $(howRank).text(data.success.how_rank);
                    }

                    awaitingVotes.splice(awaitingVotes.indexOf(projectId), 1);
                    btnClicked.removeClass('right-spin').addClass('voted');
                    btnClicked.unbind('click').click(function () {
                        return false;
                    });
                }
            })
                .fail(function () {
                    base.log('Error On vote');
                })
                .always(function () {
                    base.log('Vote executed');
                });

            return false;
        });
    },

    newsletterHandlers () {
        console.info('newsletterHandlers Init');
        let subscribeNewsletter;
        let base = this;
        let routeList = JSON.parse($('#fedora').attr('data-routes'));
        let toSubscribe;
        let registerNewsletter = function (event) {
            let form = $(this);
            let newsletterBtn = form.find('[type="submit"]');

            event.preventDefault();
            form.find('.subscribe_newsletter.error-message').text('');

            toSubscribe = $(this).find('input')
                .serializeArray()[0].value;
            if (!base.validateEmail(toSubscribe)) {
                $(this).find('.subscribe_newsletter.error-message')
                    .text('invalid email format');

                return false;
            }

            if (subscribeNewsletter) {
                return false;
            }

            newsletterBtn.addClass('right-spin');

            subscribeNewsletter = $.ajax({
                url: routeList.newsletter_register,
                type: 'post',
                dataType: 'json',
                data: { email: toSubscribe }
            }).done(function (data) {
                newsletterBtn.removeClass('right-spin');

                console.log(data);
                if (!$.isEmptyObject(data.error)) {
                    form.find('.subscribe_newsletter.error-message')
                        .text(data.error.message);
                } else {
                    console.log('success : ', data);
                    $('body').removeClass(base.formatedPopupClasses());
                    $('body').addClass('popup-open popup-verify-email-open');
                }
            })
                .fail(function () {
                    base.log('Error connecting to auth');
                })
                .always(function () {
                    base.log('jquery executed');
                    subscribeNewsletter = false;
                });

            return false;
        };

        $('#register-newsletter').submit(registerNewsletter);
        $('#register-header-newsletter').submit(registerNewsletter);
    },

    socialSharer () {
        console.info('sharer Init');
        let base = this;
        let popupMeta = {

            width: 400,
            height: 400
        };
        let vPosition = (window.screen.width / 2) - ((popupMeta.width / 2) + 10);
        let hPosition = (window.screen.height / 2) - ((popupMeta.height / 2) + 50);
        let textToCopy;
        let routeList = JSON.parse($('#fedora').attr('data-routes'));
        let sharePage;

        $('.social-share').click(function (event) {
            event.preventDefault();

            let url = $(this).attr('href');
            let popup = window.open(url, 'Social Share',
                'width=' + popupMeta.width + ',height=' + popupMeta.height +
                ',left=' + vPosition + ',top=' + hPosition +
                ',location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1');

            if (popup) {
                popup.focus();

                return false;
            }
        });

        $('#copy-clipboard').submit(function (event) {
            let toDisable = $('#copy-clipboard').find('[type="submit"]');

            event.preventDefault();
            textToCopy = $('#copy-clipboard').serializeArray()[0].value;
            base.copyToClipBoard(textToCopy);
            toDisable.hide();
            $('#copy-clipboard > .btn-wrapper ').append('<p> copied to clipboard </p>');
        });

        $('#share-friend').submit(function (event) {
            event.preventDefault();
            let yourAddress;
            let friendAddress;
            let currentRoute = $('#popup--login').attr('data-current-route');
            let shareBtn = $('#share-friend').find('[type="submit"]');

            $('.form-wrapper.your_email > .error-message').text('');
            $('.form-wrapper.friends_email > .error-message').text('');

            if (sharePage) {
                return false;
            }

            if ($('#share-friend').serializeArray().length === 2) {
                yourAddress = $('#share-friend').serializeArray()[0].value;
                friendAddress = $('#share-friend').serializeArray()[1].value;
                if (!base.validateEmail(yourAddress)) {
                    $('.form-wrapper.your_email > .error-message').text('invalid email format');

                    return false;
                }
                if (!base.validateEmail(friendAddress)) {
                    $('.form-wrapper.friends_email > .error-message').text('invalid email format');

                    return false;
                }
            } else {
                friendAddress = $('#share-friend').serializeArray()[0].value;
                yourAddress = null;
                if (!base.validateEmail(friendAddress)) {
                    $('.form-wrapper.friends_email > .error-message').text('invalid email format');

                    return false;
                }
            }

            shareBtn.addClass('right-spin');

            sharePage = $.ajax({
                url: routeList.sharer_for_friends,
                type: 'post',
                dataType: 'json',
                data: {
                    friend_email: friendAddress,
                    your_email: yourAddress,
                    route_shared: currentRoute
                }
            }).done(function (data) {
                shareBtn.removeClass('right-spin');

                if (!$.isEmptyObject(data.error)) {
                    $('.form-wrapper.friends_email > .error-message').text(data.error.message);
                } else {
                    $('body').removeClass(base.formatedPopupClasses());
                    $('body').addClass('popup-open popup-share-confirm-open');
                }
            })
                .fail(function () {
                    base.log('Error connecting to auth');
                })
                .always(function () {
                    base.log('jquery executed');
                    sharePage = false;
                });

            return false;
        });
    },

    validateEmail (email) {
        let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        return re.test(email.toLowerCase().trim());
    },

    log (...message) {
        console.log(message);
    },

    copyToClipBoard (text) {
        let textArea = document.createElement('textarea');
        let successful;

        textArea.value = text;
        document.body.appendChild(textArea);

        textArea.select();

        try {
            /**
             * @todo
             * Useless assignement ???
             */
            successful = document.execCommand('copy');
            console.log('Copy success', successful);
        } catch (err) {
            console.log('Oops, unable to copy');
        }

        document.body.removeChild(textArea);
    },
    manageLogoValidation () {
        const fileInput = $('#imgLogo');
        const errorMessage = $('#error-message-logo');

        fileInput.on('change', function (event) {
            const file = event.target.files[0];

            if (file.type !== 'image/png') {
                errorMessage.text('Please upload a PNG, the current document type is not accepted.');
                errorMessage.show();
            } else {
                errorMessage.hide();
            }
        });
    },
    manageUrlValidation () {
        const urlInput = $('input[name="web_site"]');
        const errorMessageValidation = $('#error-message-url');
        const errorMessageMandatory = $('#error-message-url-mandatory');

        urlInput.on('input', function () {
            const isValidUrl = urlInput.val() ? isValidUrlFormat(urlInput.val()) : true;
            // console.log('on input url!', isValidUrl, urlInput.val(), errorMessageValidation);

            if (!isValidUrl) {
                errorMessageValidation.removeClass('hidden-content');
                errorMessageMandatory.addClass('hidden-content');
            } else if (urlInput.val() === '') {
                errorMessageMandatory.removeClass('hidden-content');
                errorMessageValidation.addClass('hidden-content');
            } else {
                errorMessageValidation.addClass('hidden-content');
                errorMessageMandatory.addClass('hidden-content');
            }
        });

        function isValidUrlFormat (url) {
            const urlRegex = /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/;

            return urlRegex.test(url);
        }
    },
    tagCloud () {
        if ($('.tag--cloud .line').length > 0) {
            $('.tag--cloud .line').each(
                function () {
                    TweenMax.fromTo(
                        $(this),
                        Math.floor(Math.random() * 20) + 10,
                        { xPercent: 100 },
                        {
                            xPercent: -100,
                            repeat: -1,
                            delay: Math.floor(Math.random() * 3) + 1,
                            ease: Power0.easeInOut
                        }
                    );
                }
            );
        }
    },

    attachVideoCoverHandler () {
        let base = this;
        let videoElements = $('.shortlist--carousel-outer .list--carousel--project--item, .list--grid--item figure');

        if (videoElements.length > 0) {
            videoElements.each(
                function () {
                    let wrapper = $(this);
                    let video = $(wrapper).find('.play-on-hover');
                    let videoActive = false;

                    if (video.length > 0) {
                        if (('ontouchstart' in window) ||
                            (navigator.maxTouchPoints > 0) ||
                            (navigator.msMaxTouchPoints > 0)) {
                            wrapper.on(
                                'touchstart',
                                function () {
                                    videoActive = true;
                                    wrapper.addClass('hover');
                                }
                            );

                            $('html').on(
                                'touchstart',
                                function () {
                                    if (videoActive) {
                                        wrapper.removeClass('hover');
                                        wrapper.trigger('mouseleave');
                                    }
                                }
                            );
                        }

                        wrapper.on(
                            'mouseenter',
                            function () {
                                video.get(0).play();
                            }
                        );

                        wrapper.on(
                            'mouseleave',
                            function () {
                                if (base.isVideoPlaying(video.get(0))) {
                                    video.get(0).pause();
                                }
                            }
                        );
                    }
                }
            );
        }
    },

    customVideoCoverHandler () {
        let base = this;

        base.customVideoBehaviours();

        $(window).on(
            'load scroll resize',
            () => {
                base.customVideoBehaviours();
            }
        );
    },

    customVideoBehaviours () {
        let base = this;
        let videoElements = $('.custom-video');

        if (videoElements.length > 0) {
            videoElements.each(
                function () {
                    let video = $(this).find('video');

                    if (base.isInViewport(this)) {
                        video.get(0).play();
                    } else {
                        video.get(0).pause();
                    }
                }
            );
        }
    },

    /**
     * Check if element is in viewport
     * @param  {DOMElement}  element
     * @return {Boolean}
     */
    isInViewport (element) {
        let rect = element.getBoundingClientRect();

        return (
            rect.bottom >= 0 &&
            rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
            getComputedStyle(element).display !== 'none'
        );
    },

    isVideoPlaying (video) {
        return !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
    },

    attachSliderVideoHandler () {
        const base = this;

        $('.section--shortlist').each(
            function () {
                $('.video', this).click(
                    function () {
                        const video = $(this).data('video');

                        if (video) {
                            base.buildVideoPlayer($(this));
                        }
                    }
                );
            }
        );
    },

    buildVideoPlayer ($element) {
        let player = document.createElement('iframe');
        const video = $element.data('video');

        player.setAttribute('src', '//www.youtube.com/embed/' + video + '?rel=0&amp;showinfo=0&amp;autoplay=1');
        player.setAttribute('frameborder', '0');
        player.setAttribute('allowfullscreen', 'true');
        player.setAttribute('allowtransparency', 'true');

        $element.append(player);
        $element.addClass('play');
    },

    buildSlideShow () {
        const base = this;
        // const $carousel = $('#slideshow');
        const $carousel = $('#slideshow');

        if ($carousel && $carousel.length === 1) {
            const $owl = $carousel.find('.carousel-slideshow');
            const $close = $carousel.find('.close');
            const $video = $carousel.find('.video');
            const $items = $carousel.find('.item');
            let initialized = false;
            let first = false;

            $owl.owlCarousel(
                {
                    items: 1,
                    nav: true,
                    dots: false,
                    lazyLoad: true,
                    navText: [
                        '<i class="fedoraicon fi-chevron-left"></i>',
                        '<i class="fedoraicon fi-chevron-right"></i>'
                    ],
                    navContainer: $carousel.find('.carousel-nav'),
                    autoplay: false,
                    onInitialized: function (event) {
                        initialized = true;
                        $carousel.find('.length').text(event.item.count);
                    },
                    onChanged: function (event) {
                        $carousel.find('.index').text(event.item.index + 1);
                        $items.find('iframe').remove();
                        $items.find('.play').removeClass('play');

                        console.log(initialized, first);

                        if (initialized && first) {
                            const $current = $items.eq(event.item.index).find('.media-item');

                            first = false;

                            if ($current.data('video')) {
                                base.buildVideoPlayer($current);
                            }
                        }
                    }
                }
            );

            $video.click(
                function () {
                    const video = $(this).data('video');

                    if (video) {
                        base.buildVideoPlayer($(this));
                    }
                }
            );

            $close.click(
                function () {
                    $('body').removeClass('slideshow-visible');

                    $items.find('iframe').remove();
                    $items.find('.play').removeClass('play');

                    return false;
                }
            );

            $('.gallery--list .media-item').each(
                function (index) {
                    $('a', this).click(
                        function () {
                            first = true;

                            $('body').addClass('slideshow-visible');
                            $owl.trigger('to.owl.carousel', [index, 0]);

                            return false;
                        }
                    );
                }
            );
        }

        $('.custom-slideshow').each(function () {
            const $carousel = $(this).find('.slideshow');
            const $owl = $carousel.find('.carousel-slideshow');
            const $close = $carousel.find('.close');
            const $video = $carousel.find('.video');
            const $items = $carousel.find('.item');
            let initialized = false;
            let first = false;

            console.log($carousel);
            $owl.owlCarousel(
                {
                    items: 1,
                    nav: true,
                    dots: false,
                    lazyLoad: true,
                    navText: [
                        '<i class="fedoraicon fi-chevron-left"></i>',
                        '<i class="fedoraicon fi-chevron-right"></i>'
                    ],
                    navContainer: $carousel.find('.carousel-nav'),
                    autoplay: false,
                    onInitialized: function (event) {
                        initialized = true;
                        $carousel.find('.length').text(event.item.count);
                    },
                    onChanged: function (event) {
                        $carousel.find('.index').text(event.item.index + 1);
                        $items.find('iframe').remove();
                        $items.find('.play').removeClass('play');

                        console.log(initialized, first);

                        if (initialized && first) {
                            const $current = $items.eq(event.item.index).find('.media-item');

                            first = false;

                            if ($current.data('video')) {
                                base.buildVideoPlayer($current);
                            }
                        }
                    }
                }
            );

            $video.click(
                function () {
                    const video = $(this).data('video');

                    if (video) {
                        base.buildVideoPlayer($(this));
                    }
                }
            );

            $close.click(
                function () {
                    $('body').removeClass('slideshow-visible');

                    $items.find('iframe').remove();
                    $items.find('.play').removeClass('play');
                    $carousel.hide();

                    return false;
                }
            );

            $(this).find('.gallery--list .media-item')
                .each(
                    function (index) {
                        $('a', this).click(
                            function () {
                                first = true;
                                console.log(this);

                                $('body').addClass('slideshow-visible');
                                $owl.trigger('to.owl.carousel', [index, 0]);
                                $carousel.show();

                                return false;
                            }
                        );
                    }
                );
        });
    },

    buildAboutProjectCarousel () {
        const $carousel = $('.carousel-projet-about');

        if ($carousel && $carousel.length > 0) {
            $carousel.each(
                function () {
                    $('.owl-carousel', this).owlCarousel(
                        {
                            nav: true,
                            dots: false,
                            navText: [
                                '<i class="fedoraicon fi-chevron-left"></i>',
                                '<i class="fedoraicon fi-chevron-right"></i>'
                            ],
                            navContainer: $carousel.find('.carousel-nav'),
                            autoplay: false,
                            responsive: {
                                0: { items: 1 },
                                768: { items: 2 }
                            }
                        }
                    );
                }
            );
        }
    },

    buildArtistDetailGalleryCarousel () {
        const $carousel = $('.project--gallery--carousel');

        if ($carousel && $carousel.length > 0) {
            $carousel.each(
                function () {
                    $('.owl-carousel', this).owlCarousel(
                        {
                            nav: true,
                            dots: false,
                            mouseDrag: false,
                            navText: [
                                '<i class="fedoraicon fi-chevron-left"></i>',
                                '<i class="fedoraicon fi-chevron-right"></i>'
                            ],
                            navContainer: $carousel.find('.carousel-nav'),
                            autoplay: false,
                            responsive: {
                                0: { items: 1 },
                                480: { items: 2 },
                                640: { items: 3 },
                                1200: { items: 4 }
                            }
                        }
                    );
                }
            );
        }
    },

    buildMasonry (items, Isremove) {
        let grid = $('#grid--gallery');
        let gridItems = grid.find('.grid--item');
        let masonry;
        let imagesLoaded;

        if (grid.length > 0) {
            masonry = new Masonry('#grid--gallery', {
                itemSelector: '.grid--item',
                percentPosition: true
            });

            if (Isremove) {
                masonry.remove(gridItems);
            }

            if (items) {
                grid.append(items);
                masonry.appended(items);
            }

            imagesLoaded = new ImagesLoaded(grid);

            imagesLoaded.on('progress', function () {
                masonry.layout();
            });
        }
    },

    buildGalleryPagination () {
        const base = this;
        let RetrieveListGalleryAjax;
        let routeList = JSON.parse($('#fedora').attr('data-routes'));
        let btnLoadMore = $('.gallery-list--pagination').find('.btn-wrapper--load-more .btn');
        let selectYear = $('#filter-gallery');

        if (RetrieveListGalleryAjax) {
            RetrieveListGalleryAjax.abort();
        }

        btnLoadMore.click(function () {
            $('.loadind-gif').show();

            RetrieveListGalleryAjax = $.ajax({
                method: 'get',
                url: routeList.ajax_all_gallery,
                data: {
                    exist: $(this).attr('data-how-many-gallery'),
                    total: $(this).attr('data-how-many-all'),
                    date: selectYear.val()
                }
            })
                .done(function (data) {
                    let items = $(data.html.join(''));

                    btnLoadMore.attr('data-how-many-gallery', data.exist);

                    if (btnLoadMore.attr('data-how-many-gallery') === btnLoadMore.attr('data-how-many-all')) {
                        btnLoadMore.hide();
                    }

                    $('.loadind-gif').hide();
                    base.buildMasonry(items);
                })
                .fail(function () {
                    base.log('Error retrieving gallery list');
                })
                .always(function () {
                    btnLoadMore.removeClass('disabled');
                });
        });
    },

    filterGallery () {
        const base = this;
        let RetrieveListGalleryAjax;
        let routeList = JSON.parse($('#fedora').attr('data-routes'));
        let btnLoadMore = $('.gallery-list--pagination').find('.btn-wrapper--load-more .btn');
        let selectYear = $('#filter-gallery');

        if (RetrieveListGalleryAjax) {
            RetrieveListGalleryAjax.abort();
        }

        selectYear.on('change', function () {
            RetrieveListGalleryAjax = $.ajax({
                method: 'get',
                url: routeList.ajax_gallery_by_filter,
                data: { date: $(this).val() }
            })
                .done(function (data) {
                    if (data.html.length > 0) {
                        let items = $(data.html.join(''));

                        btnLoadMore.attr('data-how-many-gallery', data.pagination);
                        base.buildMasonry(items, true);
                    } else {
                        base.buildMasonry(null, true);
                    }
                })
                .fail(function () {
                    base.log('Error retrieving gallery list');
                })
                .always(function () {

                });
        });
    },

    dynamicHeight (grid, share) {
        let filter = grid.find('.grid-filter');
        let gridItems = grid.find('.grid--item:not(.grid-filter)');

        let gridHeight = gridItems[0].clientHeight + filter[0].clientHeight + 28;

        if (gridHeight > share[0].clientHeight) {
            let pad = gridHeight - share[0].clientHeight;

            share.css({ 'margin-bottom': pad });
        }
    },

    buildGallery () {
        const base = this;
        let grid = $('#grid--gallery');

        if (grid.length > 0) {
            $(window).on('resize load', function () {
                base.buildMasonry();
            });
        }

        base.buildGalleryPagination();
        base.filterGallery();
    },

    goDonation (isLogged, amount, counterPart) {
        console.log('isLogged, amount, counterPart: ', isLogged, amount, counterPart);
        let base = this;
        let blockChoice = $('.block-choice');
        let visibleChoiceCount = 0;

        base.donationAmount = amount;
        base.donationCounterPart = counterPart;

        $('#donation-amount').text(base.numberFormat(base.donationAmount, 0, false, ','));

        $('.form-radio', blockChoice).each((index, spanElement) => {
            if ($(spanElement).is(':visible')) {
                visibleChoiceCount++;
            }
        });

        if (counterPart || visibleChoiceCount === 1) {
            base.choice = 1;
            $('.error-message.choice').text('');

            base.showPopinCoordonnee();

            window.currentForm = 'donation-project';

            if (!window.isInitializedRecaptchaCoord) {
                window.grecaptcha.render('grecaptcha-coord', {
                    'sitekey': $('#grecaptcha-coord').data('sitekey'),
                    'callback': function (token) {
                        // return new Promise(function (resolve, reject) {
                        return new Promise(function () {
                            base.recaptchaCallback(token, $('.btn-coord-confirm'), base.jxComplete);
                        });
                    },
                    'size': 'invisible'
                });

                window.isInitializedRecaptchaCoord = true;
            }

            $('.btn-coord-confirm').unbind('click')
                .click(function () {
                    $('.btn-coord-confirm').prop('disabled', 'disabled');
                    $('.btn-coord-confirm').addClass('right-spin');
                    $('.btn-coord-confirm').addClass('disabled');
                    window.grecaptcha.execute();
                });
        } else {
            base.showPopinDonationProjectChoice();

            $('.btn-donation-project-choice').unbind('click')
                .click(function () {
                    $('.company-name').hide();

                    // check if no choice selected
                    if ($('#choice1').is(':checked')) {
                        base.choice = 1;
                    } else if ($('#choice2').is(':checked')) {
                        base.choice = 2;
                    } else if ($('#choice3').is(':checked')) {
                        base.choice = 3;

                        let identifianTGE = $('#tge').data('tge');
                        let tgeUrl = 'https://donate.transnationalgiving.eu/landing/' + identifianTGE + '?reserved_crowdfunding=1&once_grid=' + base.donationAmount * 100 + '&amount=' + base.donationAmount * 100 + '&frequency=once';

                        // window.location.href = tgeUrl;
                        Object.assign(document.createElement('a'), {
                            target: '_blank',
                            href: tgeUrl
                        }).click();

                        return false;
                    } else {
                        $('.error-message.choice').text('Please choose an option to proceed to continue.');

                        return false;
                    }

                    $('.error-message.choice').text('');

                    base.showPopinCoordonnee();

                    window.currentForm = 'donation-project';

                    if (!window.isInitializedRecaptchaCoord) {
                        let btn = this;

                        window.grecaptcha.render('grecaptcha-coord', {
                            'sitekey': $('#grecaptcha-coord').data('sitekey'),
                            'callback': function (token) {
                                // return new Promise(function (resolve, reject) {
                                return new Promise(function () {
                                    base.recaptchaCallback(token, $(btn), base.jxComplete);
                                });
                            },
                            'size': 'invisible'
                        });

                        window.isInitializedRecaptchaCoord = true;
                    }

                    $('.btn-coord-confirm').unbind('click')
                        .click(function () {
                            $('.btn-coord-confirm').prop('disabled', 'disabled');
                            $('.btn-coord-confirm').addClass('right-spin');
                            $('.btn-coord-confirm').addClass('disabled');
                            window.grecaptcha.execute();
                        });
                });
        }
    },

    resetDonationButtons (event, exept = false) {
        let buttons = $('.counterpart--button a');

        if (buttons.length) {
            if (exept) {
                buttons.each(function () {
                    if (exept !== $(this).parent().id) {
                        $(this).parent()
                            .attr('data-state', 'initial');
                        $(this).find('span.label')
                            .text($(this).data('text'));
                        $(this).parent()
                            .next('.button-message')
                            .fadeOut(300);
                    }
                });
            } else {
                let target = $(event.target);

                if (!target.closest('.counterpart--button a').length) {
                    buttons.each(function () {
                        $(this).parent()
                            .attr('data-state', 'initial');
                        $(this).find('span.label')
                            .text($(this).data('text'));
                        $(this).parent()
                            .next('.button-message')
                            .fadeOut(300);
                    });
                }
            }
        }
    },

    buildCounterparts () {
        let base = this;

        $(document).on('click', function (event) {
            base.resetDonationButtons(event);
        });

        $('.counterpart--form').each(
            function () {
                const element = $(this);
                const field = element.find('input');
                const button = element.find('a:not(.learn-more)');
                const minimumAllowed = parseInt(field.attr('min'));
                const maximumAllowed = parseInt(field.attr('max'));

                console.log('form has val', field.val() ? 'oui' : 'non', field.val(), minimumAllowed);

                if (field.val()) {
                    element.addClass('active');
                }
                let id = field.attr('id');
                let value = localStorage.getItem(id);

                if (value) {
                    field.val(value);
                }

                field.on(
                    'keyup change',
                    function () {
                        element.find('.message').fadeOut();
                        let id = $(this).attr('id');
                        let value = $(this).val();

                        if ($(this).val()) {
                            element.addClass('active');
                            console.log($(this).val());
                            $('#free_donation_txt').text($(this).val() * 2);
                            localStorage.setItem(id, value);
                        } else {
                            element.removeClass('active');
                        }
                    }
                );

                button.click(
                    function () {
                        if (!field.val() || field.val() !== parseInt(field.val(), 10).toString()) {
                            element.find('.message').text(element.find('.message').data('default-content'));
                            element.find('.message').fadeIn();
                        } else if (field.val() < minimumAllowed) {
                            element.find('.message').text(element.find('.message').data('amount-incorrect-min'));
                            element.find('.message').fadeIn();
                        } else if (field.val() > maximumAllowed) {
                            element.find('.message').text(element.find('.message').data('amount-incorrect-max'));
                            element.find('.message').fadeIn();
                        } else {
                            // If first click
                            // if ($(this).parent().attr('data-state') === 'initial') {
                            //     $('[data-behavior=counterpart]').hide();

                            //     // TODO: Show message and change button label here
                            //     base.resetDonationButtons(false, $(this).parent().id);

                            //     $(this).parent().attr('data-state', 'clicked');
                            //     $(this).find('span.label').text('DONATE NOW');
                            //     $(this).parent().next('.button-message').fadeIn(300);

                            //     return false;
                            // }

                            if ($(this).parent()
                                .attr('data-type') === 'free') {
                                $('[data-behavior=counterpart]').hide();
                                $('[data-behavior=freedonation]').show();
                            }

                            if (element.hasClass('donation-off') === false && element.hasClass('disabled') === false) {
                                base.goDonation(true, parseFloat(field.val()), null);
                            }
                        }

                        return false;
                    }
                );
            }
        );

        if ($('.counterpart--button').length > 1) {
            $('.counterpart--button').on('click', function () {
                // If first click
                // console.log($(this).attr('data-state'));
                // if ($(this).attr('data-state') === 'initial') {
                //     // TODO: Show message and change button label here
                //     base.resetDonationButtons(false, $(this).id);

                //     $(this).attr('data-state', 'clicked');
                //     $(this).find('span.label').text('DONATE NOW');
                //     $(this).next('.button-message').fadeIn(300);

                //     return false;
                // }

                $('[data-behavior=counterpart]').show();
                $('[data-behavior=freedonation]').hide();

                const counterPartBox = $(this).parent();

                if (counterPartBox.hasClass('disabled')) {
                    return;
                }

                console.log(counterPartBox.hasClass('counterpart--form'));

                if (counterPartBox.hasClass('counterpart--form') === false && counterPartBox.hasClass('donation-off') === false && counterPartBox.hasClass('inactive') === false) {
                    base.goDonation(true, parseFloat(counterPartBox.data('counterpart-amount')), counterPartBox.data('counterpart-id'));
                }
            });
        }
    },

    showPopinCoordonnee (errors) {
        const base = this;

        $('#donor-type-company').on('click', function () {
            if ($(this).is(':checked')) {
                $('.company-name').show();
            }
        });

        $('#donor-type-citizen').on('click', function () {
            if ($(this).is(':checked')) {
                $('.company-name').hide();
            }
        });

        if (base.choice === 2) {
            if ($('#donor-type-company').is(':checked')) {
                $('.company-name').show();
            }
            $('.with-tax').show();
        } else {
            if ($('#donor-type-citizen').is(':checked')) {
                $('.company-name').hide();
            }
            $('.with-tax').hide();
        }

        if (errors === undefined) {
            $('#popup--coordonnee .error-message-main').hide();
        } else {
            $('#popup--coordonnee .error-message-main').show();
        }
        $('body').removeClass(this.formatedPopupClasses());
        $('body').addClass('popup-open popup-coordonnee-open');
    },

    showPopinDonation () {
        $('body').removeClass(this.formatedPopupClasses());
        $('body').addClass('popup-open popup-donation-open');
        if (typeof window.fbq !== 'undefined') {
            window.fbq('track', 'InitiateCheckout');
        }
    },
    showPopinDonationProjectChoice () {
        $('body').removeClass(this.formatedPopupClasses());
        $('body').addClass('popup-open popup-donation-project-choice-open');
        // if (typeof window.fbq !== 'undefined') {
        //     window.fbq('track', 'InitiateCheckout');
        // }
    },

    showPopinThanks () {
        $('body').removeClass(this.formatedPopupClasses());
        $('body').addClass('popup-open popup-thanks-open');
    },

    showPopinGallery () {
        $('body').removeClass(this.formatedPopupClasses());
        $('body').addClass('popup-open popup--gallery-preview-open');
    },

    confirmCoordonnee (token, btnConfirm, jxComplete) {
        console.log('token: ', token);
        console.log('jxComplete: ', jxComplete);
        const coordForm = $('#popup--coordonnee');
        let hasError = false;
        // let routeList = JSON.parse($('#fedora').attr('data-routes'));
        const base = this;

        // Clear field
        coordForm.find('.error-message').text('');

        // Check required
        coordForm.find('.required').each(
            function () {
                const field = $(this).find('input, select, textarea');
                const fieldLabel = $(this).find('label');

                if (!field.val()) {
                    $(this).find('.error-message')
                        .text(fieldLabel.text() + ' is mandatory');
                    hasError = true;
                }
            }
        );

        // Check Create Account
        const createAccount = $('#create_account');
        const termAgree = $('#account_term_agree');

        if (createAccount.is(':checked')) {
            coordForm.find('.accout_data').each(
                function () {
                    const field = $(this).find('input');
                    const fieldLabel = $(this).find('label');

                    if (!field.val()) {
                        $(this).find('.error-message')
                            .text(fieldLabel.text() + ' is mandatory');
                        hasError = true;
                    }
                }
            );

            const password = $('#account_password');
            const confirmation = $('#account_password_confirmation');

            if (password.val().length < 6) {
                hasError = true;
                password.siblings('.error-message').text('The password field must contain at least 6 characters.');
            }

            if (password.val() !== confirmation.val()) {
                hasError = true;
                confirmation.siblings('.error-message').text('Password does not match.');
            }

            if (!termAgree.is(':checked')) {
                hasError = true;
                termAgree.siblings('.error-message').text('You have to agree to the Terms & Conditions of the FEDORA Platform.');
            }
        }

        // Check date
        // coordForm.find('.required-date').each(
        //     function () {
        //         const year = $(this).find('.form-year');
        //         const month = $(this).find('.form-month');
        //         const day = $(this).find('.form-day');
        //         const fieldLabel = $(this).find('label');
        //         const yearValue = year.val();
        //         const monthValue = month.val();
        //         const dayValue = day.val();

        //         if (!yearValue || !monthValue || !dayValue) {
        //             $(this).find('.error-message')
        //                 .text(fieldLabel.text() + ' is mandatory');
        //             hasError = true;
        //         } else {
        //             // Draw date from imput values for validation
        //             let inputDate = new Date(yearValue, monthValue - 1, dayValue);

        //             // Validate
        //             if (inputDate.getDate() !== dayValue && inputDate.getMonth() !== (monthValue - 1) && inputDate.getFullYear() !== yearValue) {
        //                 $(this).find('.error-message')
        //                     .text('Incorrect date');
        //                 hasError = true;
        //             }
        //         }
        //     }
        // );

        // Check if email exist
        let userMail = $('#popup--coordonnee [name=coord_email]').val();

        if ($('#popup--coordonnee [name=coord_email]').length && !userMail) {
            hasError = true;
            $('.required-email > .error-message')
                .text('Email is mandatory');
        }

        if (base.choice === 2) {
            if ($('#popup--coordonnee [name=coord_country]').val() !== 'France') {
                hasError = true;
                $('.error-message.country').text('Country must be France.');
            }

            if ($('#donor-type-company').is(':checked')) {
                if (!$('#popup--coordonnee [name=company_name]').val()
                    .trim()) {
                    hasError = true;
                    $('#popup--coordonnee [name=company_name]').siblings('.error-message')
                        .text('Name of the Company is mandatory.');
                }
            }
        }

        if (userMail && !base.validateEmail(userMail)) {
            hasError = true;
            $('#popup--coordonnee [name=coord_email]').siblings('.error-message')
                .text('Invalid email format.');
        }

        // let stripeToken = false;

        // Let's go
        if (!hasError) {
            let postData = {
                g_recaptcha_response: token,
                choice: base.choice,
                create_account: $('#create_account').is(':checked'),
                is_visible_supporter: $('#is_visible_supporter').is(':checked'),
                is_lead_company_newsletter_subscribe: $('#is_lead_company_newsletter_subscribe').is(':checked'),
                is_fedora_newsletter_subscribe: $('#is_fedora_newsletter_subscribe').is(':checked'),
                donor_type: $('#popup--coordonnee #donor-type-company').is(':checked') ? 1 : 2,
                company_name: $('#popup--coordonnee [name=company_name]').val(),
                first_name: $('#popup--coordonnee [name=coord_first_name]').val(),
                last_name: $('#popup--coordonnee [name=coord_last_name]').val(),
                address: $('#popup--coordonnee [name=coord_address]').val(),
                address_2: $('#popup--coordonnee [name=coord_address_2]').val(),
                special_code: $('#popup--coordonnee [name=coord_special_code]').val(),
                state: $('#popup--coordonnee [name=coord_state]').val(),
                country: $('#popup--coordonnee [name=coord_country]').val(),
                postal_code: $('#popup--coordonnee [name=coord_postal_code]').val(),
                city: $('#popup--coordonnee [name=coord_city]').val(),
                phone_number: $('#popup--coordonnee [name=coord_phone]').val(),
                phone_mobile: $('#popup--coordonnee [name=coord_mobile]').val(),
                coord_email: $('#popup--coordonnee [name=coord_email]').val(),
                account_password: $('#popup--coordonnee [name=account_password]').val(),
                account_password_confirmation: $('#popup--coordonnee [name=account_password_confirmation]').val(),
                account_user_terms: $('#popup--coordonnee [name=account_user_terms]').is(':checked')
            };

            postData.amount = base.donationAmount;

            if (base.donationCounterPart !== undefined && base.donationCounterPart !== null) {
                postData.counterpart = base.donationCounterPart;
            }

            $.ajax({
                method: 'post',
                url: $('.btn-donation-project-choice').data('donation-url'),
                data: postData,
                dataType: 'text'
            }).done(function (dataText) {
                let data = $.parseJSON(dataText);

                if (data.success) {
                    base.waitForPayment(data.payment_intent_client_secret, function () {
                        $('body').removeClass(base.formatedPopupClasses());
                        $('body').addClass('popup-open popup-thanks-open');
                    }, function () {
                        $('body').removeClass(base.formatedPopupClasses());
                        $('body').addClass('popup-open popup-problem-occured-open');
                    });
                } else {
                    const elementMessage = $('.counterpart--form .message');

                    if (data.failure_code === 'STRIPE_ERROR') {
                        const formFrror = $('#card-errors');

                        formFrror.text(data.message);
                    } else {
                        if (data.failure_code === 'NOT_INT') {
                            elementMessage.text(elementMessage.data('default-content'));
                        } else if (data.failure_code === 'AMOUNT_TOO_LOW') {
                            elementMessage.text(elementMessage.data('amount-incorrect-min'));
                        } else if (data.failure_code === 'AMOUNT_TOO_HIGH') {
                            elementMessage.text(elementMessage.data('amount-incorrect-max'));
                        } else if (data.failure_code === 'INCOMPLETE_USER_INFOS') {
                            elementMessage.text(elementMessage.data('amount-incorrect-max'));
                        } else {
                            base.log('Error processing donation');
                        }
                    }
                }

                $('.btn-coord-confirm').removeClass('right-spin');
                $('.btn-coord-confirm').removeClass('disabled');
                $('.btn-coord-confirm').prop('disabled', '');
            })
                .fail(function (xhr) {
                    $('.btn-coord-confirm').removeClass('right-spin');
                    let data = $.parseJSON(xhr.responseText);

                    if (data.errors !== undefined) {
                        console.log('errors : ', data.errors);
                        $.each(data.errors, function (index, value) {
                            $('#popup--coordonnee .form-wrapper.' + index + ' .error-message').html(value);
                        });
                    } else {
                        base.log('Error completing user infos');
                        base.log(data);
                    }

                    $('.btn-coord-confirm').removeClass('right-spin');
                    $('.btn-coord-confirm').removeClass('disabled');
                    $('.btn-coord-confirm').prop('disabled', '');
                });
        } else {
            $('.btn-coord-confirm').removeClass('right-spin');
            $('.btn-coord-confirm').removeClass('disabled');
            $('.btn-coord-confirm').prop('disabled', '');

            $('.error-message').each(function () {
                if ($(this).text()
                    .trim().length) {
                    let elOffset = $(this).offset().top;
                    let containerOffset = $('#popup--coordonnee > .container').offset().top;
                    let offset;

                    offset = elOffset - containerOffset - 50;

                    $('#popup--coordonnee').animate({ scrollTop: offset }, 500);

                    return false;
                }
            });
        }

        console.log('hasError', hasError);

        window.grecaptcha.reset();
    },

    newsList () {
        let routeList = JSON.parse($('#fedora').attr('data-routes'));
        let jxRetrieveNews;
        let base = this;

        $('#view-more-news').click(function () {
            let btnLoadMoreNews = $(this);

            if (!btnLoadMoreNews.hasClass('disabled')) {
                btnLoadMoreNews.addClass('disabled');

                if (jxRetrieveNews) {
                    jxRetrieveNews.abort();
                }

                let filter = btnLoadMoreNews.attr('data-filter');
                let year = btnLoadMoreNews.attr('data-year');
                let url = routeList.more_news;

                if (filter) {
                    url = routeList.more_news_filter + '/' + filter;
                }

                jxRetrieveNews = $.ajax({
                    method: 'get',
                    url: url,
                    data: {
                        count: $('.section-list--news .section-list--item').length,
                        year: year
                    }
                }).done(function (data) {
                    $($(data.join(''))).insertBefore(btnLoadMoreNews.parent().parent());
                })
                    .fail(function () {
                        base.log('Error retrieving news');
                    })
                    .always(function () {
                        if (btnLoadMoreNews.data('news-total') > $('.section-list--news .section-list--item').length) {
                            btnLoadMoreNews.removeClass('disabled');
                        } else {
                            btnLoadMoreNews.parent().parent()
                                .hide();
                        }
                    });
            }
        });
    },

    artistsList () {
        let routeList = JSON.parse($('#fedora').attr('data-routes'));
        let jxRetrieveNews;
        let base = this;

        $('#view-more-artists').click(function () {
            let btnLoadMoreArtists = $(this);

            if (!btnLoadMoreArtists.hasClass('disabled')) {
                btnLoadMoreArtists.addClass('disabled');

                if (jxRetrieveNews) {
                    jxRetrieveNews.abort();
                }

                let filter = btnLoadMoreArtists.attr('data-filter');
                let competition = btnLoadMoreArtists.attr('data-filter-competition');
                let prize = btnLoadMoreArtists.attr('data-filter-prize');
                let country = btnLoadMoreArtists.attr('data-filter-country');
                let url = routeList.more_artists;

                if (filter) {
                    url = routeList.more_artists_filter + '/' + filter;
                }

                jxRetrieveNews = $.ajax({
                    method: 'get',
                    url: url,
                    data: {
                        count: $('.section-list--artists--wrapper .artist-list--item').length,
                        competition: competition,
                        prize: prize,
                        country: country
                    }
                }).done(function (data) {
                    $('.section-list--artists--wrapper > .row--list').append($(data.join('')));
                })
                    .fail(function () {
                        base.log('Error retrieving artists');
                    })
                    .always(function () {
                        if (btnLoadMoreArtists.data('artists-total') > $('.section-list--artists .section-list--item').length) {
                            btnLoadMoreArtists.removeClass('disabled');
                        } else {
                            btnLoadMoreArtists.parent().parent()
                                .hide();
                        }
                    });
            }
        });
    },
    projectsList () {
        let routeList = JSON.parse($('#fedora').attr('data-routes'));
        let jxRetrieveProjects;
        let base = this;

        $('#view-more-projects').click(function () {
            let btnLoadMoreProjects = $(this);

            if (!btnLoadMoreProjects.hasClass('disabled')) {
                btnLoadMoreProjects.addClass('disabled');

                if (jxRetrieveProjects) {
                    jxRetrieveProjects.abort();
                }

                let filter = btnLoadMoreProjects.attr('data-filter');
                let url = btnLoadMoreProjects.attr('data-url');

                if (filter) {
                    url += '?' + filter;
                }

                jxRetrieveProjects = $.ajax({
                    method: 'get',
                    url: url,
                    data: { count: $('.section-list--projects .list--grid--item').length }
                }).done(function (data) {
                    $('.members--list--projects > .section-list--projects').append($(data.join('')));
                })
                    .fail(function () {
                        base.log('Error retrieving projects');
                    })
                    .always(function () {
                        if (btnLoadMoreProjects.data('projects-total') > $('.section-list--projects .list--grid--item').length) {
                            btnLoadMoreProjects.removeClass('disabled');
                        } else {
                            btnLoadMoreProjects.parent().parent()
                                .hide();
                        }
                    });
            }
        });
    },

    donationFeedBack () {
        if ($('body').hasClass('donation-state')) {
            this.showPopinThanks();
        }
    },

    /**
     * https://github.com/kvz/locutus/blob/master/src/php/strings/number_format.js
     *
     * @param numberInput
     * @param decimals
     * @param decPoint
     * @param thousandsSep
     * @returns {string|*}
     */
    numberFormat (numberInput, decimals, decPoint, thousandsSep) {
        let number = (numberInput + '').replace(/[^0-9+\-Ee.]/g, '');
        let n = !isFinite(+number) ? 0 : +number;
        let prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
        let sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep;
        let dec = (typeof decPoint === 'undefined') ? '.' : decPoint;
        let s = '';
        let toFixedFix = function (n, prec) {
            let k = Math.pow(10, prec);

            return '' + (Math.round(n * k) / k)
                .toFixed(prec);
        };

        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }
        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }

        return s.join(dec);
    },

    /**
     * https://stackoverflow.com/questions/42700105/how-to-remove-some-parameters-from-an-url-string
     */
    removeParam (key, sourceURL) {
        let rtn = sourceURL.split('?')[0];
        let param;
        let paramsArr = [];
        let queryString = (sourceURL.indexOf('?') !== -1) ? sourceURL.split('?')[1] : '';
        let i;

        if (queryString !== '') {
            paramsArr = queryString.split('&');
            for (i = paramsArr.length - 1; i >= 0; i -= 1) {
                param = paramsArr[i].split('=')[0];
                if (param === key) {
                    paramsArr.splice(i, 1);
                }
            }
            if (paramsArr.length > 0) {
                rtn = rtn + '?' + paramsArr.join('&');
            }
        }

        return rtn;
    },

    updateBodyClass () {
        let windowWidth = $(window).width();
        let windowHeight = $(window).height();

        if (windowHeight < 630 && windowWidth > 750) {
            $('body').addClass('shortscreen');
        } else {
            $('body').removeClass('shortscreen');
        }
    },

    initializeDeleteAccount () {
        let that = this;

        $('[data-behavior~=deleteAccountConfirm]').on('click', function () {
            $('body').removeClass(that.formatedPopupClasses());
            $('body').addClass('popup-open popup-delete-my-account-open');
        });

        $('[data-behavior~=deleteAccount]').on('click', function () {
            $('#delete-account-form').submit();
        });

        if ($('#popup-deleted-account').length > 0) {
            $('body').removeClass(that.formatedPopupClasses());
            $('body').addClass('popup-open popup-deleted-account-open');
        }
    },

    hideOrShow (trueValue, condition, target) {
        if (condition.val() === trueValue.toString()) {
            target.show();
        } else {
            target.hide();
        }
    },

    responsiveTable () {
        let content = $('body').find('.content--text');
        let table = content.find('table');
        let tableScroll = $('<div>').addClass('withscroll');

        table.before(tableScroll);
        tableScroll.html(table);
    },

    // Smooth scroll
    buildSmoothScroll (_hash, _trigger) {
        let $hashList = ['#', '#0', '#_=_'];
        let $self = $(_trigger);
        let $hash = _hash;

        if (!$hashList.includes($hash)) {
            let $target = $($hash);
            let menu = $('.main-new-menu');
            let nomineeCounter = $('.nomine-count-down');
            let offset = 0;
            let $parent = $(_trigger)
                .parent()
                .parent('.active-menu');

            if (menu.length > 0) {
                offset = menu.get(0).clientHeight;
            }

            if ($parent.length) {
                offset = 100;
            }

            if (nomineeCounter.length > 0) {
                offset = 0;// $('.shortlist-content--header').get(0).clientHeight;
            }

            if (undefined !== $target.offset()) {
                $('html, body')
                    .stop()
                    .animate({ 'scrollTop': $target.offset().top - offset }, 600, 'swing', function () {
                        if (_trigger && $self.hasClass('set-hash')) {
                            location.hash = $hash;
                        }
                    });
            }
        }
    },

    // Build orejime
    buildCookieConsent () {
        const orejimeConfig = {
            cookieName: 'orejime_cookie',
            cookieExpiresAfterDays: 365,
            privacyPolicy: '/legal-notice',
            default: true,
            mustConsent: false,
            implicitConsent: false,
            lang: 'en',
            translations: {
                en: {
                    consentModal: {
                        title: 'Information that we collect',
                        description: 'We use cookies and other technologies to help us improve your online experience on our site.\n',
                        privacyPolicy: {
                            name: 'Legal Notice and Cookie Policy',
                            text: 'Please check our "{privacyPolicy}" if you wish to know more about what type of cookies we use, the information we collect and how that information is used.\n'
                        }
                    },
                    consentNotice: {
                        changeDescription: 'Modifications have occurred since your last visit, thank you for updating your consent.',
                        description: 'We use cookies and other technologies to help us improve your online experience on our site.\nBy choosing I Accept, you consent to our use of cookies and other tracking technologies.',
                        learnMore: 'Learn more'
                    },
                    accept: 'Accept',
                    acceptAll: 'Accept all',
                    ok: 'OK',
                    save: 'Save',
                    saveData: 'Back up my configuration on the information collected',
                    decline: 'Refuse',
                    declineAll: 'Refuse all',
                    close: 'Close',
                    enabled: 'Enabled',
                    disabled: 'Disabled',
                    app: {
                        optOut: {
                            title: '(opt-out)',
                            description: 'This application is loaded by default (but you can disable it)'
                        },
                        required: {
                            title: '(always required)',
                            description: 'This application is always required'
                        },
                        purposes: 'uses',
                        purpose: 'use'
                    },
                    poweredBy: '',
                    newWindow: 'new window',
                    purposes: {
                        analytics: 'Audience analysis',
                        security: 'Security',
                        usepref: 'User preferences'
                    }
                }
            },
            apps: [
                {
                    name: 'fedora',
                    title: 'Strictly Necessary',
                    purposes: ['security', 'usepref'],
                    description: 'These cookies are essential for you to browse the website and use its features, such as accessing secure areas of the site.',
                    required: true,
                    cookie: [
                        'XSRF-TOKEN',
                        'fadora_sessions'
                    ]

                },
                {
                    name: 'performance-cookie',
                    title: 'Performance and Statistics',
                    description: 'These cookies collect information about how you use a website, like which pages you visited and which links you clicked on. None of this information can be used to identify you. It is all aggregated and, therefore, anonymized. Their sole purpose is to improve website functions.',
                    purposes: ['analytics', 'security'],
                    required: false,
                    cookies: [
                        '_ga',
                        '_gat',
                        '_gid',
                        '__utma',
                        '__utmb',
                        '__utmc',
                        '__utmt',
                        '__utmz',
                        '_fbp',
                        'fr',
                        'datr',
                        'sb',
                        'wd'
                    ]
                }
            ]
        };

        // init orejime
        Orejime.init(orejimeConfig);

        console.log('orejime', Orejime);
    },

    setCookie (name, value, days) {
        let expires = '';

        if (days) {
            let date = new Date();

            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + (value || '') + expires + '; path=/';
    },

    getCookie (name) {
        let nameEQ = name + '=';
        let ca = document.cookie.split(';');

        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];

            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }

        return null;
    },

    eraseCookie (name) {
        document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },

    checkNewsletterCookie () {
        let newsletterFirstVisit = this.getCookie('newsletter_first_visit');

        if (!newsletterFirstVisit) {
            let cookieName = 'newsletter_first_visit';
            let cookieValue = 'true';

            this.setCookie(cookieName, cookieValue, 100);
            console.log('newsletter_first_visit = false');
            this.showNewsletterPopup();
        } else {
            console.log('newsletter_first_visit', newsletterFirstVisit);
        }
    },

    waitFreeDonationForPayment (clientSecret, paymentSuccess, paymentFailure) {
        let base = this;
        let mainErrorMsg = $('#payement_methode .error-message-main');
        const formFrror = $('#card-errors');

        $('body').removeClass(base.formatedPopupClasses());
        // $('body').addClass('popup-open popup-payment-open');
        mainErrorMsg.hide();

        // $('[data-behavior~=proceed-payment]').on('click', function (ev) {
        // ev.preventDefault();
        // $('.btn-membership-confirm').prop('disabled', 'disabled');
        // $('.btn-membership-confirm').addClass('right-spin');
        // $('.btn-membership-confirm').addClass('disabled');
        mainErrorMsg.hide();
        formFrror.text('');

        window.stripe.confirmCardPayment(clientSecret, { payment_method: { card: window.card } }).then(function (result) {
            if (result.error) {
                $('.btn-membership-confirm').prop('disabled', '');
                $('.btn-membership-confirm').removeClass('right-spin');
                $('.btn-membership-confirm').removeClass('disabled');
                $('body').removeClass(base.formatedPopupClasses());
                formFrror.text(result.error.message);
                mainErrorMsg.show();
            } else {
                if (result.paymentIntent.status === 'succeeded') {
                    paymentSuccess();
                } else {
                    paymentFailure();
                    throw new Error('Stripe payment exception');
                }
            }
        });
        // });
    },

    waitForPayment (clientSecret, paymentSuccess, paymentFailure) {
        let base = this;
        let mainErrorMsg = $('#popup--payment .error-message-main');
        const formFrror = $('#card-errors');

        $('body').removeClass(base.formatedPopupClasses());
        $('body').addClass('popup-open popup-payment-open');
        mainErrorMsg.hide();

        $('[data-behavior~=proceed-payment]').on('click', function (ev) {
            ev.preventDefault();
            $('.btn-proceed-payment').prop('disabled', 'disabled');
            $('.btn-proceed-payment').addClass('right-spin');
            $('.btn-proceed-payment').addClass('disabled');
            mainErrorMsg.hide();
            formFrror.text('');

            window.stripe.confirmCardPayment(clientSecret, { payment_method: { card: window.card } }).then(function (result) {
                $('.btn-proceed-payment').prop('disabled', '');
                $('.btn-proceed-payment').removeClass('right-spin');
                $('.btn-proceed-payment').removeClass('disabled');
                $('body').removeClass(base.formatedPopupClasses());
                if (result.error) {
                    formFrror.text(result.error.message);
                    mainErrorMsg.show();
                } else {
                    if (result.paymentIntent.status === 'succeeded') {
                        paymentSuccess();
                    } else {
                        paymentFailure();
                        throw new Error('Stripe payment exception');
                    }
                }
            });
        });
    },

    verticalTimeline () {
        const $vTimeline = document.querySelector('.timeline-vertical');

        if ($vTimeline) {
            const $sameDate = document.querySelectorAll('.same-date');

            $sameDate.forEach(
                function (value) {
                    const previousSibling = value.previousElementSibling;
                    const previousSiblingPosition = previousSibling.offsetTop;
                    const previousSiblingHeight = previousSibling.offsetHeight;
                    const valueHeight = value.offsetHeight;
                    const valueHeightDiff = (previousSiblingHeight - valueHeight) / 2;
                    const itemPosition = previousSiblingPosition + valueHeightDiff;

                    if (window.innerWidth > 576) {
                        value.style.cssText = `
                        position: absolute;
                        top: ` + itemPosition + `px;`;
                    } else {
                        value.style.cssText = '';
                    }
                }
            );
            document.querySelector('.timeline-vertical').style.cssText = '';
        }
    },

    /**
     * Check is number is float
     * @param {number} n
     * @returns {boolean}
     */
    isFloat (n) {
        return Number(n) === n && n % 1 !== 0;
    },

    /**
     * Script strate key figure
     */
    initStrateKeyFigure () {
        const strateKeyFigures = document.querySelectorAll('.section-list--key_figures');

        if (strateKeyFigures) {
            let observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.intersectionRatio > 0.5) {
                        const keyFigure = entry.target.querySelector('.key-figure');
                        const end = parseFloat(keyFigure.dataset.keyfigure);
                        const options = { decimalPlaces: this.isFloat(end) ? 1 : 0 };
                        const countUp = new CountUp(keyFigure, end, options);

                        countUp.start();
                        observer.unobserve(entry.target);
                    }
                });
            }, { threshold: [0.5] });

            strateKeyFigures.forEach(strateKeyFigures => {
                strateKeyFigures.querySelectorAll('.item').forEach(item => {
                    observer.observe(item);
                });
            });
        }
    },

    cardActive () {
        if ($('.grille-wrapper .card').length > 0) {
            $('.card').each(function () {
                $(this).on(
                    'click',
                    function () {
                        if ($(this).hasClass('active')) {
                            $(this).removeClass('active');
                        } else {
                            $('.card').removeClass('active');
                            $(this).addClass('active');
                        }
                    }
                );
            });
        }
    },

    CTAFixed () {
        if ($('.cta-donation-fixed')) {
            $('.cta-donation-fixed').on(
                'click',
                function () {
                    let el = $('.cta-donation-fixed');

                    if (el.hasClass('active')) {
                        el.addClass('hideContent');
                        setTimeout(
                            function () {
                                el.removeClass('active');
                                el.removeClass('hideContent');
                            },
                            200
                        );
                    } else {
                        el.addClass('showContent');
                        setTimeout(
                            function () {
                                el.addClass('active');
                                el.removeClass('showContent');
                            },
                            200
                        );
                    }
                }
            );

            $(window).on(
                'click',
                function (isBtn) {
                    let el = $('.cta-donation-fixed');

                    if (el.hasClass('active')) {
                        el.addClass('hideContent');
                        setTimeout(
                            function () {
                                el.removeClass('active');
                                el.removeClass('hideContent');
                            },
                            200
                        );
                    }
                }
            );
        }
    },

    AddActiveClass () {
        $('.sub-menu-list a').on('click', function () {
            // console.log($(this).parent('.menu-list li > a').hasClass('active'));

            // Remove 'active' class from all links
            $('.sub-menu-list a').removeClass('active');

            // Add 'active' class to the clicked link
            $(this).addClass('active');
        });
    }
};

export default globalUtils;
